export default {
    "en": {
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address."
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds.",
            "not_exists": "해당 계정이 존재하지 않습니다."
        },
        "paragraphs": {
            "has_not_service_account": "No service account exists.",
            "has_not_service_account_detail": "Please contact our sales team to use Kollus Live.",
            "list_empty": "No information was found.",
            "list_loading": "A channel list is loading. Please wait.",
            "recording_list_empty": "No recording file was found.",
            "placeholder_search": "Enter your keywords",
            "copied_clipboard": "Copied to clipboard.",
            "please_select_file": "Select files to upload.",
            "are_you_sure": "Do you want this?",
            "are_you_sure_that_update_this": "Are you sure you want to edit this?",
            "placeholder_select_division": "Select a division.",
            "placeholder_select_channel": "Select a channel.",
            "placeholder_select_broadcast": "Select a live stream.",
            "page_navigation": "%{from} of %{total}",
            "last_updated_date": "Last Updated: %{date}",
            "not_use_policy": "Not applicable.",
            "use_capture_block_policy": "Apply the policy.",
            "please_select_item": "Please select an item and try again.",
            "channel": {
                "it_is_not_on_air": "This channel is off-air.",
                "latest_broadcast_list_empty": "No recent live broadcasts exist.",
                "hidden_list_desc": "When hiding a live channel, a live broadcast will be paused immediately and not available until it is unhidden.",
                "hidden_list_empty": "No hidden channel exists.",
                "customer_code_tip": "A customer code consists of only lowercase English letters, numbers, and hyphens.",
                "concurrently_view_limit_tip": "When exceeding the concurrent viewers limit, access to a live broadcast will be available, but it will be restricted later based on the time requested to the video gateway.",
                "use_duplicate_block_if_no_open_channel_tip": "Only private channels can apply duplicate IDs policy.",
                "meta_title_pattern": {
                    "sample_desc": "A live stream will be named based on the codes below.",
                    "sample1": "[CHANNEL_TITLE]: channel title",
                    "sample2": "[CHANNEL_CUSTOMER_CODE]: channel customer code",
                    "sample3": "[BROADCAST_COUNTING]: broadcast count",
                    "sample4": "[BROADCAST_CREATING_DATE]: created date",
                    "sample5": "[PROGRAM_TITLE] : program title"
                },
                "recording_file_policy": {
                    "save_separate_file": "When a live stream is cut-off, the recording will be saved as a separate file.",
                    "append_one_file": "When the cut-off time of a live stream is less than 3 minutes, the recording will be saved as a separate file."
                },
                "recording_file_pattern": {
                    "tip": "After a live stream ends, a recording will be named based on the defined naming pattern.",
                    "sample_desc": "The details of the recording naming pattern are as below.",
                    "sample1": "[CHANNEL_KEY]: channel key",
                    "sample2": "[CHANNEL_CUSTOMER_CODE]: customer code",
                    "sample3": "[BROADCAST_KEY]: broadcast key",
                    "sample4": "[BROADCAST_COUNTING]: broadcast count",
                    "sample5": "[BROADCAST_CREATING_DATE]: created date",
                    "sample6": "[RECORDING_START_DATETIME]: recording start date and time",
                    "sample7": "[RECORDING_TYPE]: recording type"
                },
                "creator_tip": "When you add a channel, a creator code and stream key will be automatically created. Codes and keys can be added up to 3 and can be changed by a manager or administrator.",
                "logo_tip_1": "A logo image will be displayed in the upper left corner of the player.",
                "logo_tip_2": "Please upload your logo images in GIF or PNG format. The maximum size is %{maxWidth}x%{maxHeight} pixels.",
                "idle_screen_kind_tip_1": "An idle screen will be displayed on a broadcast list, or before starting and ending a live stream.",
                "idle_screen_kind_tip_2": "When there is no snapshot or no poster, a default screen will be displayed on the player.",
                "idle_screen_kind": {
                    "use_poster": "Display the uploaded poster",
                    "use_snapshot": "Display the most recent snapshot"
                },
                "poster_tip_1": "A poster image will be displayed as an idle screen image before starting and ending a live stream.",
                "poster_tip_2": "Please upload poster images in GIF or PNG format. The maximum size is %{maxWidth}x%{maxHeight} pixels.",
                "snapshot_tip_1": "A snapshot image will be taken and saved every 5 seconds during live streaming. It will be updated to the most recent image.",
                "snapshot_tip_2": "Snapshot requests will be included in your traffic and charge.",
                "placeholder_title": "Enter a channel name.",
                "placeholder_customer_code": "Enter a channel code.",
                "download_in_7days": "Only recordings from the last 7 days can be viewed.",
                "select_start_date_bigger": "The start date should be later than {date}.",
                "select_end_date_smaller": "The end date should be prior to {date}.",
                "mornitorring_message": {
                    "broadcast_start": "A creator is starting a live broadcast.",
                    "broadcast_stop": "A creator is ending a live broadcast."
                },
                "country_restriction_tip_1": "You can allow or block a live broadcast to specific countries per channel.",
                "country_restriction_tip_2": "Please select a country to allow or block.",
                "cmaf_desc": "This is CMAF-based low-latency HLS streaming for real-time live services.",
                "low_latency_hls_desc": "Inclued devices running iOS 17.0, Android 7.0",
                "not_available_desc": "This is an unavailable channel. <br>When you wish to use it, please contact your Kollus account manager (AM, biz@catenoid.net)",
                "aes128_disabled_desc": "AES-128 cannot be used for channels with 'Low-Latency  Live' type.",
                "profile_changed": "The encoding profile was changed by selecting the 'Low-Latency Live' type.",
                "multi_drm_changed": "'Multi-DRM' cannot be used by selecting 'AES-128'."
            },
            "recording_file": {
                "preview_tip1": "Loading a video can take longer when the file size of the recording is large."
            },
            "profile": {
                "list_empty": "No data was found.",
                "screen_type": {
                    "portrait": "Portrait",
                    "landscape": "Landscape "
                },
                "group_tip1": "Please request a person in charge to add or edit an encoding profile.",
                "group_tip2": "You cannot change profiles when a channel goes live.",
                "use_max_count_tip": "Profiles can be added up to {count}.",
                "use_least_count_tip": "At least {count} profile should be on."
            },
            "statistics": {
                "channel_download_tip": "Channel analytics will be updated 30 minutes after ending a live stream.",
                "view_environment_download_tip": "Viewer analytics will be updated 30 minutes after ending a live stream.",
                "storage_usage_download_tip": "Recording usage analytics will be updated 30 minutes after ending a live stream.",
                "service_usage_download_tip": "Service usage analytics will be updated 30 minutes after ending a live stream.",
                "service_usage_file_download_tip": "Files will be added based on the sorting set in the list at the bottom."
            },
            "message": {
                "success": {
                    "remove": "Successfully deleted.",
                    "change": "Successfully changed.",
                    "store": "Successfully saved.",
                    "create": "Successfully added.",
                    "update": "Successfully edited.",
                    "destory": "Successfully deleted.",
                    "copy": "Successfully copied.",
                    "remove_broadcast": "The live stream has been successfully deleted.",
                    "remove_recording_file": "The recording has been successfully deleted.",
                    "upload": "The file has been uploaded successfully.",
                    "duplicate_block_player_unregister": "Your playback devices have been successfully unregistered.",
                    "duplicate_block_player_reset": "All playback devices have been successfully reset.",
                    "block_user_limit_register": "The selected users have been successfully blocked.",
                    "block_user_no_limit_register": "The selected users have been successfully unblocked.",
                    "remove_program_file": "The file has been successfully deleted.",
                    "remove_program": "The program has been successfully deleted.",
                    "clone_channel": "Copied the channel."
                },
                "confirm": {
                    "create_item": "Are you sure you want to add this?",
                    "update_item": "Are you sure you want to edit this?",
                    "remove_item": "Are you sure you want to delete this?",
                    "hide_channels": "Are you sure you want to hide this channel? All live broadcasts will be stopped immediately.",
                    "restore_channels": "Are you sure you want to restore this channel?",
                    "destroy_channels": "Are you sure you want to permanently delete this channel?",
                    "remove_broadcast": "Are you sure you want to delete this live stream?",
                    "remove_recording_file": "Are you sure you want to delete this recording file?",
                    "update_stream_key": "Are you sure you want to change your creator stream key?",
                    "start_duplicate_recording_file": "Are you sure you want to start manual recording?",
                    "stop_duplicate_recording_file": "Are you sure you want to end manual recording?",
                    "duplicate_block_player_unregister": "Are you sure you want to unregister playback devices?",
                    "duplicate_block_player_register": "Are you sure you want to register playback devices?",
                    "duplicate_block_player_reset": "Are you sure you want to reset all playback devices?",
                    "block_user_limit_register": "Are you sure you want to block users?",
                    "block_user_no_limit_register": "Are you sure you want to unblock users?",
                    "remove_program_file": "Are you sure to delete '{title}' {contents_type}?",
                    "cancel_upload_file": "Are you sure you want to cancel to upload?",
                    "remove_program": "Are you sure to delete '{title}' {contents_type}?",
                    "disable_channel_status": "Are you sure you want to switch off this channel? Users are not allowed to access the live broadcast in this channel.",
                    "enable_channel_status": "Are you sure you want to switch on this channel? Users are allowed to access the live broadcast in this channel."
                },
                "error": {
                    "create": "Failed to save.",
                    "update": "Failed to edit.",
                    "change": "Failed to change.",
                    "remove": "You cannot delete this.",
                    "hide_channels": "Failed to hide the channel.",
                    "restore_channels": "Failed to restore the channel.",
                    "destroy_channels": "Failed to delete the channel.",
                    "channel_info": "Failed to get the channel information.",
                    "channel_encoding_info": "Failed to get the encoding information.",
                    "exceed_maximum_creator_count": "You can add up to 3 creators.",
                    "update_creator_info": "Failed to edit the creator information.",
                    "reload_creator_stream_key": "Failed to refresh creator streaming key.",
                    "remove_file": "Failed to delete file.",
                    "update_statistics": "Failed to get the analytics information.",
                    "remove_broadcast": "Failed to delete the live broadcast.",
                    "remove_recording_file": "Failed to delete the recorded file.",
                    "upload": "Failed to upload files.",
                    "create_creator": "Failed to add creator account.",
                    "remove_creator": "Failed to delete creator account.",
                    "remove_creator_onair": "The creator on-air cannot be deleted.",
                    "exist_in_blocks": "This has been added to blocked countries.",
                    "exist_in_allows": "This has been added to allowed countries.",
                    "remove_country": "Failed to delete the country.",
                    "empty_country": "Select a country to add.",
                    "google_auth": "Failed to authenticate Google account.",
                    "logout_google_auth": "Failed to delete Google account.",
                    "check_login_right": "Check your privileges.",
                    "duplicate_recording_not_on_air": "A recording is available only when a broadcast goes live.",
                    "duplicate_recording_cannot_stop": "A recording can be ended only when a broadcast is being recorded.",
                    "duplicate_block_player_unregister": "Failed to unregister the playback device.",
                    "duplicate_block_player_reset": "Failed to reset all playback devices.",
                    "remove_program_file_ready_schedule": "This cannot be deleted. It has already been scheduled.",
                    "remove_program_file": "This file cannot be deleted.",
                    "remove_program_done_schedule": "This program cannot be deleted. It has already been programmed.",
                    "remove_program": "This program cannot be deleted.",
                    "disable_channel_status": "Failed to switch off the channel.",
                    "enable_channel_status": "Failed to switch on the channel.",
                    "clone_channel": "Failed to copy the channel.",
                    "exist_in_referer_domains": "This has been already added to the domain list.",
                    "empty_domain": "Please enter the domain to be added.",
                    "empty_check_domains": "No domains exist in the allow list.",
                    "empty_reject_domains": "No domains exist in the block list."
                }
            },
            "live_action_logs": {
                "user_login": "User signed in",
                "creator_login": "Creator signed in",
                "channel_created": "Added a channel",
                "channel_updated": "Updated a channel",
                "channel_restored": "Restored a channel",
                "channel_trashed": "Hidden a channel",
                "channel_deleted": "Deleted a channel",
                "broadcast_started": "Started broadcast",
                "broadcast_paused": "Paused broadcast",
                "broadcast_resumed": "Resumed broadcast",
                "broadcast_stopped": "Stopped broadcast",
                "country_restriction_created": "Added country restriction",
                "country_restriction_deleted": "Deleted country restriction",
                "file_transfer_created": "Added recording transfer",
                "file_transfer_updated": "Edited recording transfer",
                "file_transfer_deleted": "Deleted recording transfer",
                "file_transfer_enabled": "Switched off recording transfer",
                "file_transfer_disabled": "Switched on recording transfer",
                "syndication_created": "Added syndication",
                "syndication_updated": "Edited syndication",
                "syndication_deleted": "Deleted syndication",
                "syndication_enabled": "Switched on syndication",
                "syndication_disabled": "Switched off syndication",
                "content_provider_updated": "Updated the service account",
                "recording_file_download": "Downloaded the recording",
                "statistics_channel_download": "Downloaded channel analytics",
                "statistics_viewer_environment_download": "Downloaded viewer analytics",
                "statistics_storage_usage_download": "Downloaded recording usage analytics",
                "statistics_service_usage_download": "Downloaded recording usage analytics",
                "statistics_service_log_download": "Downloaded service log",
                "creator_updated": "Edited a creator",
                "creator_created": "Added a creator",
                "creator_deleted": "Deleted a creator",
                "duplicate_recording_file_save_started": "Started saving manual recording",
                "duplicate_recording_file_save_stopped": "Ended saving manual recording",
                "media_content_deleted": "Deleted a program",
                "media_content_upload_prepared": "Ready to upload a program",
                "program_created": "Added a program",
                "program_updated": "Edited a program",
                "program_deleted": "Deleted a program",
                "statistics_service_usage_new_download": "Downloaded service usage analytics",
                "chatting_file_download": "Downloaded chatting file",
                "channel_enabled": "Switched on a channel",
                "channel_disabled": "Switched off a channel",
                "chatting_statistics_usage_download": "Downloaded chatting usage analytics",
                "chatting_statistics_users_download": "Downloaded chatting participant analytics",
                "chatting_statistics_messages_download": "Downloaded chatting message analytics"
            },
            "please_select": "Select destination",
            "remote_path_desc": "Remote Path",
            "file_transfer_tip1": "Once you add a recording transfer destination, your recordings will be transferred automatically.",
            "file_transfer_tip2": "You can add transfer destination up to {count}.",
            "file_transfer_max_count_tip": "Recording transfer destinations can be used up to {count}.",
            "youtube_category_tip1": "In the case of YouTube, according to Google's policy, you must select one of the YouTube categories to upload a video.",
            "youtube_category_tip2": "This setting applies to all video content uploaded to YouTube from this channel.",
            "kollus_category_tip1": "You must select one of the YouTube categories to upload a video according to Google's policy.",
            "kollus_category_tip2": "This setting applies to all video content uploaded to YouTube from the channel.",
            "file_transfer_count_tip": "Recording transfer destinations can be added up to {count}.",
            "please_google_auth": "Please authenticate your Google account.",
            "loaded_youtube_category": "The category to upload files to has been loaded. Please select a category.",
            "syndication_max_count_tip": "You can syndicate channels up to {count}.",
            "syndication_count_tip": "You can add syndication up to {count}.",
            "syndication_tip1": "Once you add syndication information of external platforms to be linked, a live broadcast will be available through added external platforms.",
            "syndication_tip2": "You can add syndication information up to {count}. ",
            "idle_screen_kind_poster": "The uploaded poster image will be the idle image of this channel.",
            "idle_screen_kind_snapshot": "The idle screen of this channel is a live snapshot.",
            "license_key_empty": "No license key exists. Please contact a person in charge.",
            "downloadable_within_7_days": "Downloadable files are available for 7 days.",
            "contract_tip1": "The marked features include additional charges.",
            "contract_tip2": "In case you want to change other items, directly edit the settings of a channel.",
            "placeholder_service_account_name": "Enter a service account name.",
            "members_empty": "No user information was found. Please contact a person in charge.",
            "creators_per_channels_manage_tip1": "A creator is a person who runs a live broadcast.",
            "creators_per_channels_manage_tip2": "A live broadcast is available only when a code and a stream key are entered.",
            "has_no_contract": "There is no contract linked to the service account.",
            "has_no_contract_detail": "Please contact our sales team to use Kollus Live.",
            "broadcast_update_callback_tip": "When Live Callback is switched to On, live broadcast status such as broadcast start, pause, and end will be updated to a callback URL.",
            "recording_file_transfer_callback_tip": "When Recording Transfer Callback is switched to On, recording transfer information will be updated to a callback URL.",
            "lms_callback_tip": "When LMS Callback is switched to On, the content information will be updated to a callback URL. Only HTTPS can be used for an LMS callback URL.",
            "placeholder_callback_url": "Please enter a callback URL",
            "recording_size_tip": "When a recording file size exceeds its maximum capacity of 4G during live broadcast, it will be automatically saved in a single file.",
            "recording_duration_tip1": "",
            "recording_duration_tip2": "When the duration of live broadcast is over {N} minutes, it will be automatically saved.",
            "division_delayed_tip1": "",
            "division_delayed_tip2": "When the cut-off time of live broadcast is less than {N} minutes, it is recognized as the same live broadcast.",
            "oauth_name_tip": "Enter a name to recognize yourself.",
            "oauth_redirect_url_tip": "Enter a redirect URL to create a client.",
            "oauth_personal_access_token_desc": "A new personal access token was created. Please keep this information and save it safely. You can use this token to make API requests.",
            "oauth_no_clients": "No OAuth client was found.",
            "something_wrong": "An error occurred, please try again.",
            "oauth_no_tokens": "No personal access token was found.",
            "oauth_no_authorized_applications": "No authorized application was found.",
            "duplicate_recording_tip1": "Save a recording file manually.",
            "duplicate_recording_tip2": "When a live broadcast goes live, the recording start and end buttons are activated. When you click the button, you can have a delay of up to 5 seconds.",
            "duplicate_recording_tip3": "When you add a channel, your setting for auto save will be applied as the same.",
            "duplicate_recording_in_use": "({username}) is manually recording now. Please wait.",
            "duplicate_recording_ing_tip": "You can save up to 4 hours of recording files at 2Mbps (bitrate).",
            "broadcast_update_callback_desc": "It is a description of the parameters used in a live callback.",
            "recording_file_transfer_callback_desc": "It is a list of parameters for recording transfer.",
            "chatting_exclusive_player_disable_desc1": "Chatting is not available when using the Kollus Exclusive Player.",
            "chatting_exclusive_player_disable_desc2": "To use chatting, You must switch off the Kollus Exclusive Player.",
            "chatting_use_yes_no_tip": "When Chatting is switched to On, you can change its settings with the options below.",
            "chatting_type_tip": "In the case of embedded type, chat can be applied immediately without additional development, but for a development type, you need a contract to use it.",
            "chatting_type_embed_tip": "You can use chatting by linking Chatroll.",
            "chatting_service_not_available": "You can use it after adding the Chatroll setting in the service account contract.",
            "placeholder_chatting_embed_code": "When using, enter [HTML embed code].",
            "chatting_concurrent_user_tip1": "Chatting admin and creator accounts are also included in the number of concurrent chatting participants.",
            "chatting_concurrent_user_tip2": "Please join a chatting before users join in.",
            "chatting_not_available_desc1": "A contract is required to use a chatting.",
            "chatting_not_available_desc2": "When chatting input is not available even after signing in contract,",
            "chatting_not_available_desc3": "please check whether chatting is on or off on the channel edit page.",
            "exceed_max_channel_count": "The number of available channels has been exceeded. Please contact a person in charge.",
            "duplicate_block_policy_unavailable": "This feature is not allowed due to the duplicate IDs policy currently applied.",
            "placeholder_search_client_user_id": "Please enter your user ID.",
            "catting_available_at_html5": "Chatting is only available on HTML5 players.",
            "program_placeholder_title": "Please enter the program title.",
            "recently_ordered_files": "Recently Added Files",
            "program_file_search": "Search Files",
            "broadcast_duration_desc": "When a file is added, it is automatically calculated and increased.",
            "program_already_reserved_schedule": "The time overlaps with other live broadcasts that have already been scheduled.",
            "program_cannot_destroy_ongoing_or_finished": "You cannot delete live programs that are currently going live.",
            "program_file_uploaded": "{file_name} has been uploaded and it will be added to the file list.",
            "program_file_upload_only_mp4": "Only the mp4 file format can be uploaded.",
            "program_select_channel": "After selecting a channel, you can add a program.",
            "program_select_start_date": "Please select a start date.",
            "chatting_profile_photo_tip_1": "Change the default profile picture for users with no profile picture.",
            "chatting_profile_photo_tip_2": "The maximum image size is %{maxWidth}x%{maxHeight} pixels.",
            "play_callback_tip": "When Playback Callback is switched to On, playback information on your Kollus Exclusive Player will be updated to a callback URL.",
            "program_file_upload_desc1": "It is recommended to switch on transcoding for a seamless environment, but it may take some time to convert.",
            "program_file_upload_desc2": "If you switch off transcoding,",
            "program_file_upload_desc3": "The 48kHz is the standard audio sample rate.",
            "program_file_upload_desc4": "Make sure to unify your audio and video format.",
            "program_wait_file_search": "Idle screen search",
            "program_wait_file_upload_only": "Please upload images in GIF or PNG format. The maximum size is %{maxWidth}x%{maxHeight} pixels.",
            "program_wait_file_duration_min": "Please enter the duration of the idle screen. Duration can be set to within 360 minutes.",
            "program_check_audio_format_error": "The audio is in a different format. Transcoding is required, otherwise, the audio is out of sync when a file is replaced.",
            "program_check_video_format_warning": "The video is in a different format. Functions such as syndication may have problems when a file is changed. Are you sure you want to add it as it is?",
            "program_can_register_after_5min": "Programming is available after 5 minutes from now.",
            "program_file_please_register": "Please upload the files to add to a program.",
            "channel_cannot_change_kind_program_to_general": "The channel type cannot be changed. It has a scheduled program.",
            "file_not_exist_for_download": "No file is available for download.",
            "chatting_admin_id_tooltip": "The Chatting Admin IDs are the value entered for user IDs to JSON web token. Please enter a space as a delimiter.",
            "chatting_disabled_when_use_anonymous": "Profile picture settings are not available when you are using anonymous chatting.",
            "chatting_profile_photo_cannot_disable_when_not_display_profile_photo": "You cannot change the default profile image without displaying your profile picture.",
            "chatting_profile_photo_cannot_upload_when_not_disable_profile_photo": "You cannot change the profile image when you are using the default profile image.",
            "chatting_scalable_tip": "When you expect to have more than 3000 chat users, switch on large-scale chatting.",
            "chatting_send_status_tip": "This feature is only available when using chatting SDK.",
            "chatting_restart_broadcast_to_apply": "All items excluding the Chatting Admin ID can be updated only when a live broadcast is resumed.",
            "referer_check_tip_1": "When you want to set your content to be played or blocked in a specific domain, please enter the domain host. To enter multiple hosts, separate them with commas.",
            "referer_check_tip_2": "Use \"#\" to allow all characters before a specific string such as a wildcard.",
            "referer_check_tip_3": "(e.g., #bcd.com will allow all access from abcd.com, go.abcd.com, aaabcd.com).",
            "referer_check_domain_rule": "Please check the domain.",
            "chatting_statistics_tip": "Chatting usage analytics will be updated 30 minutes after ending a live stream.",
            "statistics_timezone_tip": "The time zone for analytics is set to GMT/UTC +0.",
            "latency_config_check_integer_gte_0": "{attribute} must be an integer greater than or equal to 0.",
            "latency_config_check_integer_gte_1": "{attribute} must be an integer greater than or equal to 1.",
            "profile_type_match_tip": "The type of the encoding profile group must be equal to the type of the encoding profile.",
            "program_wait_file_upload_only_desc": "Please upload images for the idle screen in JPG or PNG format. The maximum size is %{maxWidth}x%{maxHeight} pixels.",
            "not_use_filelive": "The recording policy has not been applied.",
            "not_use_webrtc": "The WebRTC policy has not been applied.",
            "not_use_contract": "The policy has not been applied.",
            "profile_group_type_match_tip": "The type of the encoding profile group must match the type of the channel.",
            "program_same_audio_codec_and_sample_rate": "A Program only can have video files using the same audio codec and audio sample rate.",
            "program_conflicting_schedule": " The selected time slot is already booked for another video.",
            "program_wait_file_duration_min_max": "A Program duration should be 360 minutes or less",
            "program_register_modal_title_placeholder": "Please input your program title",
            "program_register_modal_contents_info": "A Program only can have video files using the same audio codec and audio sample rate.",
            "program_title_required": "Program title is required",
            "program_channel_required": "Channel is required",
            "program_wait_content_duration_over_zero": "A Program duration should be 360 minutes or less.<br> The idle screen duration must be an integer greater than or equal to 1.",
            "program_content_file_required": "A program should have one or more video files. <br> A Program only can have video files using the same audio codec and audio sample rate.",
            "program_check_video_format_error": "The format of the selected video file is different from the format of the files in the program. This may cause problems during the live streaming.\nPlease select video files with the same video codec and frame rates.",
            "program_hide_channel_notification": "A hidden channel can't publish a live stream",
            "schedule_live_on_modify_error": "You cannot modify details of a program when it goes on live",
            "schedule_live_end_modify_error": "You cannot modify details of a program after the live streaming is ended",
            "schedule_live_modify_success": "Schedule of a live streamig is changed",
            "schedule_live_modify_fail": "Failed to change the live streaming schedule",
            "schedule_copy_warning": "Are you sure to save and duplicate the modified information?\nIf you cancel, your changes will be lost.",
            "schedule_modal_close_warning": "None of the information you entered will be saved. Do you still want to close?",
            "schedule_modal_close_modified_save": "Do you want to save the modified information?",
            "program_check_video_format_each_contents": "Selected videos have the different video resolution and/or frame rate.",
            "program_check_audio_format_each_contents": "Selected Videos have the different audio codec and/or sample rate.",
            "program_check_video_format_between_contents_and_wait": "The idle screen has the different video resolution and/or frame rate from videos in the program.",
            "program_check_audio_format_between_contents_and_wait": "The idle screen has the different audio codec and/or sample rate from videos in the program.",
            "program_check_video_format_confirm": "The selected videos have the diferrent {fail_format}. This may cause probles during the live streaming.",
            "no_contents_list": "No search results were found",
            "program_select_channel_placeholder": "Please choose a channel for a program.",
            "program_contents_search": "Search for videos",
            "program_have_none_transcoding_done_files": "Transcoding must be completed before a video can be scheduled.",
            "program_wait_file_upload_wrong_format": "You cannot use special symbols for a file name.",
            "program_upload_fail_error": "Once your network is restored, please upload a video file.",
            "not_use_cmaf": "The CMAF policy has not been applied",
            "not_use_aes128": "Whn you wish to use this feature, please contact your Kollus technical representative (PE, tech_support@catenoid.net)",
            "block_external_output_display_desc": "Block TV-OUT output from mobile devices or beam projector output from PC (Windows).",
            "block_angle_brackets": "Angle brackets(<, >) cannot be entered.",
            "invalid_service_account_input": "Emojis and Angle brackets(<, >) cannot be entered in the service account name."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "words": {
            "login": "Sign In",
            "logout": "Sign Out",
            "login_account": "Sign In Account",
            "has_not_service_account": "No service account",
            "role": "Role",
            "timezone": "Time Zone",
            "language": "Language",
            "broadcast": "Live",
            "broadcasts": "Live Broadcasts",
            "live": "Live Broadcasts",
            "filesize": "File Size",
            "list": "List",
            "channel": "Channel",
            "channels": "Channels",
            "all_broadcasts": "All Broadcasts",
            "all_channels": "All Channels",
            "live_onair": "On Air",
            "email": "Email",
            "email_address": "Email",
            "password": "Password",
            "remember_me": "Remember me",
            "select_all": "Select All",
            "key": "Key",
            "preview": "Preview",
            "visitor_counts": "View",
            "name": "Name",
            "count": "Count",
            "title": "Title",
            "customer_code": "Customer Code",
            "all": "All",
            "open": "Public",
            "restore": "Restore",
            "not_open": "Private",
            "live_status": "Live Status",
            "live_status_on": "On Air",
            "live_status_off": "Off Air",
            "shared_status": "Visibility",
            "shared_status_on": "Public",
            "shared_status_off": "Private",
            "channel_manage": "Channel",
            "channel_list": "Channel List",
            "hidden_channel_list": "Hidden",
            "recording_files": "Recording List",
            "creator": "Creator",
            "decoration": "Logo/Poster/Snapshot",
            "statistics_manage": "Analytics",
            "statistics": "Analytics",
            "statistics_channel": "Channel",
            "statistics_viewer_env": "Viewer",
            "storage_usage": "Recording Usage",
            "service_logs": "Service Log",
            "preference": "Settings",
            "general": "General",
            "basic_info": "General",
            "profile": "Profile",
            "members": "User",
            "close": "Close",
            "go_detail": "More Detail",
            "datetime": "Date",
            "save": "Save",
            "cancel": "Cancel",
            "add": "Add",
            "upload": "Upload",
            "copy": "Copy",
            "search": "Search",
            "use_yes": "On",
            "use_no": "Off",
            "remove": "Delete",
            "logo": "Logo",
            "idle_screen_kind": "Idle Screen",
            "poster": "Poster",
            "snapshot": "Snapshot",
            "started_at": "Started",
            "ended_at": "Ended",
            "broadcast_interval": "Time",
            "live_counts": "Live Count",
            "concurrently_viewer_limit": "Concurrent Viewers Limit",
            "latest_live_broadcast": "Recent Broadcasts",
            "title_and_creator": "Title/Creator",
            "started_and_ended": "Started/Ended",
            "accumulate_viewers": "Cumulative Viewers",
            "hidden_date": "Hidden Date",
            "profile_group_name": "Group Name",
            "profile_selected_name": "Profile Type",
            "profile_group_screen_type": "Mode",
            "media_profile_groups": "Encoding Profile",
            "is_shared": "Visibility",
            "use_duplicate_block": "Duplicate IDs Management",
            "meta_title_pattern": "Metadata Title",
            "meta_description": "Metadata Content",
            "recording_file_pattern": "Recording Naming Pattern",
            "recording_file_policy": "Recording Saving Option",
            "use_capture_block": "Recording/Capture Prevention",
            "use_exclusive_player": "Kollus Exclusive Player",
            "use_timeshift": "Timeshift",
            "creator_nickname": "Creator Nickname",
            "creator_code": "Creator Code",
            "creator_stream_key": "Creator Stream Key",
            "create_channel": "Add Channel",
            "edit_channel": "Edit Channel",
            "hide_channels": "Hide",
            "remove_channels": "Delete Channel",
            "restore_channels": "Restore Channel",
            "remove_recording_files": "Delete Recording",
            "remove_broadcasts": "Delete Broadcast",
            "broadcast_list": "Broadcast List",
            "today": "Today",
            "store": "Save",
            "edit": "Edit",
            "description": "Detail",
            "video_gateway_link": "Video Gateway Link",
            "channel_key": "Channel Key",
            "link": "Link",
            "application": "Application",
            "stream_key": "Stream Key",
            "show": "View",
            "delete": "Delete",
            "detail_information": "Live Details",
            "creator_information": "Creator Details",
            "all_creators": "All Creators",
            "onair_creator": "Creators On Air",
            "broardcast_ip_address": "Live Broadcast IP",
            "broadcast_started_at": "Live Broadcast Time",
            "broadcast_location": "Live Broadcast Region",
            "recording_file_created_volume": "File Size",
            "live_count": "Live Count",
            "statistics_download": "Download",
            "statistics_storage_usage": "Recording Usage",
            "statistics_service_logs": "Service Log",
            "action_datetime": "Date/Time",
            "division": "Log Name",
            "action_user": "User",
            "subject_name": "Subject",
            "action_message": "Detail",
            "user_login": "User Sign In",
            "creator_login": "Creator Sign In",
            "channel_created": "Add Channel",
            "channel_updated": "Edit Channel",
            "channel_restored": "Restore Channel",
            "channel_trashed": "Hide Channel",
            "channel_deleted": "Delete Channel",
            "broadcast_started": "Start Broadcast",
            "broadcast_paused": "Pause Broadcast",
            "broadcast_resumed": "Resume Broadcast",
            "broadcast_stopped": "Stop Broadcast",
            "no_limit": "Unlimited",
            "period_today": "Today",
            "period_3d": "3 Days",
            "period_7d": "7 Days",
            "period_30d": "30 Days",
            "previous": "Previous",
            "next": "Next",
            "watch_time": "Watch Time",
            "max_acc_user": "Cumulative Viewers",
            "total_acc_user": "Unique Viewers",
            "max_cur_user": "Maximum Concurrent Viewers",
            "total_visit_count": "View",
            "total_broadcast_interval": "Total Broadcast Time",
            "average_broadcast_interval": "Average Broadcast Time",
            "total_watch_time": "Total Watch Time",
            "average_watch_time": "Average Watch Time",
            "watch_user": "Viewer Count",
            "visit_count": "View",
            "traffic": "Traffic",
            "transfer": "Transfer",
            "response_code": "Response Code",
            "country": "Country",
            "domainOrUrl": "Domain/URL",
            "device": "Device",
            "os": "Operating System",
            "browser": "Browser",
            "channel_name": "Channel Name",
            "live_name": "Live Name",
            "acc_user_count": "Cumulative Viewers",
            "cur_user_count": "Concurrent Viewers",
            "request_count": "View",
            "response_code_1xx_desc": "Informational",
            "response_code_2xx_desc": "Success",
            "response_code_3xx_desc": "Redirection",
            "response_code_4xx_desc": "Client Error",
            "response_code_5xx_desc": "Server Error",
            "unit_user_count": "",
            "unit_request_count": "",
            "live_info": "Live Info",
            "channel_info": "Channel Info",
            "live_title": "Live Title",
            "remove_recording_file": "Delete",
            "kollus_live_cms": "Kollus LIVE",
            "quality": "Quality",
            "video": "Video",
            "audio": "Audio",
            "use_yes_no": "On",
            "codec": "Codec",
            "resolution": "Resolution",
            "bitrate": "Bitrate",
            "media_player_policy_none": "Off",
            "media_player_policy_only": "On",
            "media_player_policy_only_at_mobile": "Kollus Mobile Player",
            "country_restriction": "Country Restriction",
            "allowed_country": "Allowed Country",
            "blocked_country": "Blocked Country",
            "allowed_country_select": "Allow",
            "blocked_country_select": "Block",
            "recording_file_transfer": "Recording Transfer",
            "register": "Add",
            "file_transfer_kind": "Destination",
            "category": "Category",
            "youtube_upload_open": "Upload YouTube",
            "authentication": "Authentication",
            "aws_bucket_name_desc": "AWS S3 Bucket Name",
            "aws_access_key_id_desc": "AWS S3 Access Key",
            "aws_secret_access_key_desc": "AWS S3 Secret Access Key",
            "use_encryption": "Encryption",
            "google_auth_go": "Google Account Authentication",
            "platform_name": "Platform Name",
            "syndication": "Syndication",
            "category_key": "Category Key",
            "contract_info": "Contract Info",
            "service_account": "Service Account",
            "service_account_name": "Service Account Name",
            "service_account_key": "Service Account Key",
            "member_manage": "User",
            "service_duration": "Service Period",
            "service_type": "Service Type",
            "contract_channel_count": "Contracted Channel",
            "max_birate": "Maximum Bitrate",
            "player": "Player",
            "forwarding_target_limit_count": "Destination Limit",
            "license_key": "License Key",
            "platform": "Platform",
            "event": "Event",
            "mobile_encoder_sdk": "Mobile Encoder SDK",
            "create_date": "Created",
            "expire_date": "Expired",
            "package_name/bundle_id": "Package Name/Bundle ID",
            "authentication_key": "Authentication Key",
            "ios": "iOS",
            "android": "Android",
            "content_provider_updated": "Edit Service Account",
            "login_info": "Sign In Account",
            "user_info": "User List",
            "manage": "Management",
            "role_owner": "Administrator",
            "role_manager": "Manager",
            "role_viewer": "Operator",
            "role_creator": "Creator",
            "menu": "Menu",
            "detail_function": "Description",
            "view": "View",
            "modify": "Edit",
            "channel_edit": "Edit Channel",
            "channel_hide/restore": "Hide/Unhide Channel",
            "channel_detail": "Details",
            "mnu_live": "Live",
            "recording_file_download": "Download Recording",
            "recording_file_remove": "Delete Recording",
            "live_info_desc": "Live Information\n(title, details, poster, syndication)",
            "kollus_live_role_guide": "Kollus Live Privilege Guide",
            "creators_per_channels_manage": "Manage Creator",
            "download": "Download",
            "security_key": "Security Key",
            "custom_key": "User key",
            "callback": "Callback",
            "broadcast_update_callback": "Live Callback",
            "broadcast_update_callback_url": "Live Callback URL",
            "recording_file_transfer_callback": "Recording Transfer Callback",
            "recording_file_transfer_callback_url": "Recording Transfer Callback URL",
            "lms_callback": "LMS Callback",
            "lms_callback_url": "LMS Callback URL",
            "live_broadcast_policy": "Live Broadcast Policy",
            "save_maximum_volume": "Maximum Save",
            "save_interval_time": "Interval Save",
            "unit_minute": "minute(s)",
            "recording_file_policy_save_no_file": "No Save",
            "recording_file_policy_save_auto_file": "Auto Save",
            "recording_file_policy_save_manual_file": "Manual Save",
            "recording_file_policy_save_all_file": "Auto/Manual Save",
            "save_auto": "Auto Save",
            "save_manual": "Manual Save",
            "oauth_clients": "OAuth Client",
            "personal_access_tokens": "Personal Access Token",
            "client_id": "Client ID",
            "secret": "Secret",
            "create_new_client": "Add Client",
            "create_new_token": "Add Token",
            "redirect_url": "Redirect URL",
            "scopes": "Scope",
            "create_client": "Add Client",
            "edit_client": "Edit Client",
            "go_kollus_live_api": "Kollus Live API",
            "create_token": "Add Token",
            "personal_access_token": "Personal Access Token",
            "authorized_applications": "Authorized Application",
            "statistics_channel_download": "Download Channel Analytics",
            "statistics_viewer_env_download": "Download Viewer Analytics",
            "statistics_storage_usage_download": "Download Recording Usage Analytics",
            "statistics_service_usage_download": "Download Recording Usage Analytics",
            "statistics_service_log_download": "Download Service Log Analytics",
            "recording_started_at": "Started",
            "recording_ended_at": "Ended",
            "recording_type": "Type",
            "play_now": "View",
            "recording_download": "Download",
            "auto": "Auto",
            "manual": "Manual",
            "recording_start": "Start Recording",
            "recording_stop": "End Recording",
            "duplicate_recording_start": "Start Manual Recording ",
            "duplicate_recording_stop": "End Manual Recording",
            "duplicate_recording_ing": "Manual Recording",
            "broadcast_key": "Broadcast Key",
            "stream_start": "Start Stream",
            "stream_stop": "End Stream",
            "stream_pause": "Pause Stream",
            "stream_resume": "Resume Stream",
            "recording_file_name": "Recording File Name",
            "recording_file_kind": "Recording File Type\n(segment: auto recording, duplicate: manual recording]\n",
            "recording_file_transfer_result": "Transfer Result\n(0: failure, 1: success)",
            "chatting": "Chatting",
            "chatting_use_yes_no": "Chatting",
            "chatting_type": "Chatting Type",
            "chatting_type_embed": "Embedded Type",
            "catting_go_chatroll_config": "Chatroll Setting",
            "chatting_position": "Chatting Location",
            "top": "Top",
            "bottom": "Bottom",
            "right": "Right",
            "left": "Left",
            "type": "Type",
            "auto_recording_files_viewer": "View Auto Recording",
            "manual_recording_files_viewer": "View Manual Recording",
            "auto_recording_file": "Auto Recording File",
            "manual_recording_file": "Manual Recording File",
            "auto_recording": "Auto Recording",
            "manual_recording": "Manual Recording",
            "help_center": "Support",
            "aws_region_key_desc": "AWS S3 Region Key",
            "password_change": "Change Password",
            "old_password": "Old Password",
            "new_password": "New Password",
            "password_confirm": "Confirm Password",
            "video_gateway": "Video Gateway",
            "show_channel_title_at_vg": "Show channel title",
            "show_broadcast_title_at_vg": "Show live title",
            "show_meta_description_at_vg": "Show metadata",
            "duplicate_block": "Duplicate IDs",
            "duplicate_block_manage": "Duplicate IDs Management",
            "duplicate_block_sessions": "Current Session",
            "duplicate_block_logs": "Concurrent Log",
            "player_id": "Player ID",
            "client_user_id": "User ID",
            "session_unregister": "Ended Session",
            "duplicate_block_policy": "Duplicate IDs Policy",
            "duplicate_block_policy_allow_one_device_at_same_time": "one device at a time",
            "duplicate_block_policy_allow_registered_device": "registered devices",
            "duplicate_block_policy_allow_registered_one_device_at_same_time": "registered one device at a time",
            "duplicate_block_reset_all_player_id": "reset all devices",
            "duplicate_block_delete_player_id": "unregister player devices",
            "duplicate_block_delete_client_user_id": "unregister user devices",
            "reset": "Reset",
            "player_id_register": "Register Player ID",
            "created_at": "Registered",
            "capture_block_policy": "Screen Capture Prevention Policy",
            "capture_block_policy_stop_playback_and_alert_warning": "",
            "capture_block_policy_stop_playback_alert_warning_and_restrict_user_content_access": "pause video, user alert, restrict content",
            "capture_block_policy_use_teruten": "pattern-based prevention",
            "capture_block_policy_use_teruten_stop_playback_and_alert_warning": "pause video, user alert, pattern-based prevention ",
            "capture_block_policy_use_teruten_block_process": "pattern-based prevention, block process",
            "capture_block_policy_block_process": "block process",
            "capture_block": "Capture Prevention",
            "capture_block_logs": "Prevention Log",
            "used_capture_tool": "Used Capture Tool",
            "player_kmpi": "Kollus Mobile Player(iOS)",
            "player_kmpa": "Kollus Mobile Player(Android)",
            "player_mac": "Kollus Mac Player",
            "player_knp": "Kollus Exclusive Player(NP Player) - Windows(Safari]\n",
            "player_kap": "Kollus Exclusive Player(ActiveX) - IE",
            "player_kag": "Kollus V3/V4 Player(HTML5, Application)",
            "player_type": "Player Type",
            "player_block": "Block",
            "player_unblock": "Unblock",
            "block_user_list": "Blocked List",
            "hardware_id": "Hardware ID",
            "general_channel": "General",
            "program_channel": "Program",
            "file_list": "File List",
            "program_schedule": "Scheduling",
            "file_name": "Fine Name",
            "file_size": "File Size",
            "play_time": "Live Time",
            "upload_time": "Uploaded",
            "program_count_finished": "Completed",
            "program_count_ready": "Scheduled",
            "program_manage": "Program",
            "file_register": "Upload Files",
            "program_register": "Schedule a new program",
            "program_modify": "Edit",
            "no_title": "Untitled",
            "file": "File",
            "total_broadcast_time": "Total Broadcast Time",
            "broadcast_start_date": "Broadcast Start Date",
            "channel_kind": "Type",
            "program_created": "Add Program",
            "program_updated": "Edit Program",
            "program_deleted": "Delete Program",
            "media_content_deleted": "Delete Program",
            "media_content_upload_prepared": "Upload Ready",
            "transcoding_on": "Transcoding",
            "transcoding_error": "Transcoding Error",
            "include_removed_channels": "Deleted Channel",
            "chatting_limit_count": "Messages per Minute",
            "chatting_join_message": "Welcome Message",
            "chatting_profile_photo": "Profile Picture",
            "chatting_profile_photo_display": "Profile Picture",
            "chatting_profile_default_photo_change": "Change Profile Picture",
            "play_callback": "Playback Callback",
            "play_callback_url": "Playback Callback URL",
            "transcoding": "Transcoding",
            "status": "Status",
            "use_possible": "On",
            "register_wait": "Upload Ready",
            "register_fail": "Upload Failed",
            "wait_media_content": "Idle Screen",
            "wait_media_content_duration_m": "Idle Screen Duration",
            "program": "Program",
            "hide_channel": "Hidden Channel",
            "statistics_service_usage": "Service Usage",
            "syndication_time": "Syndication Time",
            "start_time": "Started",
            "end_time": "Ended",
            "statistics_service_usage_new_download": "Download Service Usage Analytics",
            "chatting_anonymous_chat": "Anonymous Chatting",
            "chatting_enable_block": "Block User",
            "chatting_download": "Download Chatting",
            "chatting_file_download": "Download Chatting File",
            "chatting_unique_user_count": "Chatting Participant Count",
            "chatting_sum_message_count": "Chatting Message Count",
            "chatting_admin_id": "Chatting Admin ID",
            "vod_storage_statistics": "VOD Storage Analytics",
            "enable": "On",
            "disable": "Off",
            "channel_enabled": "Channel On",
            "channel_disabled": "Channel Off",
            "multi_drm": "Multi-DRM",
            "widevine_revoked_device": "Widevine Revocation",
            "allow_play": "Allow Play",
            "block_play": "Block Play",
            "chatting_download_fields": "Select Fields",
            "concurrently_chatting_limit": "Chatting Participants Limit",
            "chatting_download_file_type": "File Type",
            "file_live": "File Live",
            "scalable_chatting": "Large Scale Chat",
            "webrtc_channel": "WebRTC Channel",
            "chatting_send_status": "Like",
            "chatting_usage_statistics": "Chatting Usage",
            "chatting_statistics_usage_download": "Download Chat Usage Analytics",
            "chatting_unique_count": "Chatting Participant Count",
            "chatting_message_count": "Chatting Message Count",
            "average_chatting_unique_count": "Chatting Member Average Count",
            "average_chatting_message_count": "Chatting Message Average Count",
            "referer_config": "Referer",
            "referer_check_domains": "Domain Allow List",
            "referer_reject_domains": "Domain Block List",
            "referer_check_option_disable": "Off",
            "referer_check_option_check": "Allow Specific Domain",
            "referer_check_option_reject": "Block Specific Domain",
            "domain": "Domain",
            "channel_clone": "Copy Channel",
            "profile_group_key": "Profile Group Key",
            "webrtc": "WebRTC",
            "realtime_live": "Realtime Live",
            "recording_live": "Recording Live",
            "realtime": "Realtime",
            "recording": "Recording",
            "latency_time_config": "Latency Time",
            "unit_second": "sec.",
            "unit_quantity": "",
            "size": "File Size",
            "program_ready_time": "A Schduled time for live streaming",
            "audio_codec": "Audio Codec",
            "sample_rate": "Audio Sample Rate",
            "frame_rate": "Frame Rate",
            "original": "Original Video File",
            "tr": "TR",
            "dont_delete_message": "You can't delete this video because it is on the scheduled program list",
            "transcoding_fail": "Transcoding Failed",
            "contents_list": "List of Videos",
            "wait_media_content_list": "List of idle screens",
            "contents_register": "Video Upload",
            "wait_media_content_register": "Idle Screen Upload",
            "upload_file_desc": "Drag and drop your videos or select them in your browser",
            "upload_progress": "{progress}% is completed",
            "upload_status_wait": "Wait for upload",
            "upload_status_done": "Upload progress is completed",
            "upload_status_cancel": "Upload progress is canceled",
            "upload_status_fail": "Upload progress is failed",
            "success_upload_clear": "Clear the completed upload list",
            "max_uploading_count_message": "Please upload 20 videos or less, simultaneously.",
            "file_max_size_message": "Please upload a video file of 2GB in size or less",
            "contents": "Videos",
            "recoding_channel": "Recording Channel",
            "all_recoding_channel": "List of all recording channel",
            "program_live_status_live": "on lIve",
            "program_live_status_end": "live streaming is ended",
            "contents_name_search": "Search by a video name",
            "only_upload_success_contents_comments": "List of succefully uploaded videos",
            "admin_login": "Administrator Log in",
            "upload_transcoding_desc_1_1": "The transcoding progress rate is displayed in the video list menu.",
            "upload_transcoding_desc_1_2": "Video playtime and file size(GiB) is displayed in the video list menu after the transcoding is completed",
            "upload_transcoding_desc_2_1": "The transcoding progress rate is displayed in the video list menu.",
            "upload_transcoding_desc_2_2": "Video playtime and file size(GiB) is displayed in the video list menu after the transcoding is completed",
            "upload_transcoding_desc_2_3": "A idle screen is transcoded automatically",
            "program_title": "Program title",
            "contents_select": "Video Select",
            "program_hide_channel_info": "When hiding a live channel, a live broadcast will be stopped immediately and not available until it is unhidden.",
            "max_age": "Max age",
            "chunk_duration": "Chunk duration",
            "chunk_count": "Chunk count",
            "complete_upload_clear": "Remove uploaded videos from the list.",
            "transcoding_wait": "Waiting",
            "max_fps": "Maximum FPS",
            "chatting_block_dup_nickname": "Block duplicate nicknames",
            "cmaf": "Low-Latency Live",
            "programming_live": "Scheduled Live",
            "unit_millisecond": "ms",
            "chunk_part_duration_cmaf": "Chunk part duration",
            "channel_low_latency_hls": "HLS for low-end devices",
            "use_aes128": "AES-128",
            "channel_not_available": "Unavailable",
            "block_external_output_display": "Block external display output"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "lower_enum_key": "The selected {attribute} is invalid.",
            "optimus_exists": "The selected {attribute} is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "https_url": "{attribute} must be an https URL.",
                "ip_port": "{attribute} must be ip{port}."
            },
            "no_emoji": "Emoji cannot be used.",
            "no_angle_brackets": "Angle brackets(<, >) cannot be entered.",
            "attributes": {
                "meta_title_pattern": "Metadata Title",
                "meta_description": "Metadata Content",
                "title": "Title",
                "upload_file": "File",
                "customer_code": "Customer Code",
                "editor_title": "Title",
                "category": "Category",
                "link": "Link",
                "stream_name": "Stream Key",
                "category_key": "Category Key",
                "chunk_count_cmaf": "chunk count",
                "chunk_duration_cmaf": "chunk duration",
                "chunk_part_duration_cmaf": "chunk part duration"
            }
        }
    },
    "ja": {
        "passwords": {
            "password": "パスワードは6文字以上かつ確認フィールドと一致しなければなりません。",
            "reset": "パスワードをリセットしました。",
            "sent": "パスワードリマインダーを送信しました。",
            "token": "パスワードリセットトークンが失効されています。",
            "user": "このメールアドレスと一致するユーザーが存在しません。"
        },
        "auth": {
            "failed": "認証情報と一致するレコードがありません。",
            "throttle": "ログイン失敗数の制限を超えたため只今ログインができません。{seconds} 秒後にお試しください。",
            "not_exists": "アカウントが存在しません。"
        },
        "paragraphs": {
            "has_not_service_account": "ログインアカウントに連係されたサービスアカウントが存在しません。",
            "has_not_service_account_detail": "Kollus Liveを利用するためにはKollus営業窓口にお問い合わせください。",
            "list_empty": "受信する情報がありません。",
            "list_loading": "読み込み中",
            "recording_list_empty": "受信する録画ファイルの情報がありません。",
            "placeholder_search": "検索ワードを入力してください。",
            "copied_clipboard": "クリップボードにコピーされました。",
            "please_select_file": "アップロードするファイルを選択してください。",
            "are_you_sure": "本当に実行しますか？",
            "are_you_sure_that_update_this": "変更しますか？",
            "placeholder_select_division": "区分を指定してください。",
            "placeholder_select_channel": "チャンネルを指定してください。",
            "placeholder_select_broadcast": "ライブ放送を指定してください。",
            "page_navigation": "%{total} 件の中 %{from} - %{to}",
            "last_updated_date": "最終更新日: %{date}",
            "not_use_policy": "ポリシーを適用しません。",
            "use_capture_block_policy": "ポリシーを適用します。",
            "please_select_item": "アイテムを選択してから再度実行してください。",
            "channel": {
                "it_is_not_on_air": "現在放送中ではありません。",
                "latest_broadcast_list_empty": "最近のライブ放送履歴がありません。",
                "hidden_list_desc": "チャンネルを非表示状態した場合にはチャンネルのライブ放送が中止され、表示状態に変更するまでライブ放送ができません。",
                "hidden_list_empty": "非表示履歴がありません。",
                "customer_code_tip": "顧客コードはローマ字、数字、'_', '-' のみ可能です。",
                "concurrently_view_limit_tip": "視聴者数制限値を超えた場合、先にアクセスを許可し、視聴者のリクエスト時間に基き後で制限を掛けます。",
                "use_duplicate_block_if_no_open_channel_tip": "重複再生遮断機能は非公開チャンネルのみ使用可能です。",
                "meta_title_pattern": {
                    "sample_desc": "以下の値で放送が生成されます。",
                    "sample1": "[CHANNEL_TITLE] : チャンネルタイトル",
                    "sample2": "[CHANNEL_CUSTOMER_CODE] : チャンネル顧客コード",
                    "sample3": "[BROADCAST_COUNTING] : 放送回次",
                    "sample4": "[BROADCAST_CREATING_DATE] : 放送生成日付",
                    "sample5": "[PROGRAM_TITLE] : プログラムタイトル"
                },
                "recording_file_policy": {
                    "save_separate_file": "ライブストリーミング信号が切断される度に別途のファイルとして保存",
                    "append_one_file": "ライブストリーミング信号の切断状態から3分以内に復帰した場合に一つのファイルとして保存"
                },
                "recording_file_pattern": {
                    "tip": "ライブ終了後録画ファイルをダウンロードする時に指定した規則の通りにファイル名が生成されて保存されます。",
                    "sample_desc": "以下の値で放送が生成されます。",
                    "sample1": "[CHANNEL_KEY] : チャンネルキー",
                    "sample2": "[CHANNEL_CUSTOMER_CODE] : チャンネル顧客コード",
                    "sample3": "[BROADCAST_KEY] : ライブ放送キー",
                    "sample4": "[BROADCAST_COUNTING] : 放送回次",
                    "sample5": "[BROADCAST_CREATING_DATE] : 放送生成日付",
                    "sample6": "[RECORDING_START_DATETIME] : 録画開始日時",
                    "sample7": "[RECORDING_TYPE] : 録画タイプ"
                },
                "creator_tip": "チャンネルを登録するとCreator1人のコード及びパスワードが自動生成されます。Creatorは最大3人まで生成できます。 Creatorコード及びパスワードはチャンネルに登録・追加の時に生成され、Creatorニックネーム及びパスワードは管理者から変更できます。",
                "logo_tip_1": "ロゴはPlayerの左上に表示される予定です。",
                "logo_tip_2": "ロゴは横 %{maxWidth}px, 縦 %{maxHeight}px 以下のgifまたはpngファイルのみ使用できます。",
                "idle_screen_kind_tip_1": "ライブリスト及びライブ開始前または終了後にPlayerの待ち受け画面を設定します。",
                "idle_screen_kind_tip_2": "ライブのスナップショットがない場合、またはポスターを登録していない場合にはデフォルトのPlayer画面が表示されます。",
                "idle_screen_kind": {
                    "use_poster": "既に登録したポスターを使用",
                    "use_snapshot": "該当チャンネルの最新ライブ放送のスナップショットを表示"
                },
                "poster_tip_1": "ポスターイメージはライブ放送開始前または終了後のPlayerの待ち受け画面として表示する予定です。",
                "poster_tip_2": "ポスターイメージは横幅 %{maxWidth}px, 縦幅 %{maxHeight}px以下のサイズのgifまたはpngファイルを使用してください。",
                "snapshot_tip_1": "スナップショットイメージはライブ放送中5秒毎に取られて保存し、最新のイメージに更新して保存します。",
                "snapshot_tip_2": "スナップショットの読み込みに掛かるトラフィックも課金データに含まれます。",
                "placeholder_title": "チャンネル名を入力してください。",
                "placeholder_customer_code": "チャンネルコードを入力してください。",
                "download_in_7days": "最近7日間の録画ファイルのみプレビューができます。",
                "select_start_date_bigger": "開始日付は {date} より後の日付のみ選択できます。",
                "select_end_date_smaller": "終了日付は {date} より前の日付のみ選択できます。",
                "mornitorring_message": {
                    "broadcast_start": "Creatorが放送を開始しています・・・",
                    "broadcast_stop": "Creatorが放送を終了しています・・・"
                },
                "country_restriction_tip_1": "国別アクセス遮断　チャンネル別に指定された国からの接続を許可または制限することが可能です。",
                "country_restriction_tip_2": "国を指定して追加してください。",
                "cmaf_desc": "より迅速なリアルタイムライブサービスを実現するための、CMAFベースの低遅延HLSストリーミングです。",
                "low_latency_hls_desc": "iOS17.1, Android7.0 以下のディバイスが該当します。",
                "not_available_desc": "利用できないチャンネルです。<br>ご利用を希望される場合は、営業担当者（jp_team@catenoid.net）までお問い合わせください。",
                "aes128_disabled_desc": "チャンネルタイプが低遅延放送の場合、AES-128は使用できません。",
                "profile_changed": "低遅延ライブ チャンネルタイプを選択したため、エンコーディングプロファイルが変更されました。",
                "multi_drm_changed": "AES-128を利用中なのでMulti-DRMのご利用できません。"
            },
            "recording_file": {
                "preview_tip1": "録画ファイルのサイズが大きいほど読み込み時間が長くなる可能性があります。"
            },
            "profile": {
                "list_empty": "受け取れる情報がありません。",
                "screen_type": {
                    "portrait": "縦",
                    "landscape": "横"
                },
                "group_tip1": "エンコーディングプロファイルを追加または変更するには担当者までお問い合わせください。",
                "group_tip2": "ライブ放送中のチャンネルがある場合、エンコードプロファイルの変更はできません。",
                "use_max_count_tip": "エンコーディングプロファイルは最大 {count} 個まで登録できます。",
                "use_least_count_tip": "エンコーディングプロファイルプロファイルは最低 {count} 個以上登録してください。"
            },
            "statistics": {
                "channel_download_tip": "チャンネル統計はライブ放送終了の30分後から確認できます。",
                "view_environment_download_tip": "視聴者環境統計はライブ放送終了の30分後から確認できます。",
                "storage_usage_download_tip": "録画ファイル利用統計はライブ配信が終了してから30分後に確認することができます。",
                "service_usage_download_tip": "サービス利用統計は放送終了後30分経過してから集計されます。",
                "service_usage_file_download_tip": "下段リストから設定した整列順の通りにファイルが生成されます。"
            },
            "message": {
                "success": {
                    "remove": "正常に削除されました。",
                    "change": "正常に変更されました。",
                    "store": "正常に保存されました。",
                    "create": "正常に生成されました。",
                    "update": "正常に更新されました。",
                    "destory": "正常に削除されました。",
                    "copy": "正常にコピーされました。",
                    "remove_broadcast": "放送が正常に削除されました。",
                    "remove_recording_file": "録画ファイルが正常に削除されました。",
                    "upload": "正常にアップロードされました。",
                    "duplicate_block_player_unregister": "再生デバイスの登録が解除されました。",
                    "duplicate_block_player_reset": "全ての再生デバイスの登録が解除されました。",
                    "block_user_limit_register": "指定したユーザーの視聴が制限されました。",
                    "block_user_no_limit_register": "指定のユーザーの視聴制限を解除しました。",
                    "remove_program_file": "ファイルが削除されました。",
                    "remove_program": "プログラムが削除されました。",
                    "clone_channel": "チャンネルがコピーされました。"
                },
                "confirm": {
                    "create_item": "選択したアイテムを生成しますか？",
                    "update_item": "選択したアイテムを更新しますか？",
                    "remove_item": "選択したアイテムを削除しますか？",
                    "hide_channels": "選択したチャンネルを非表示状態にしますか？ライブ放送は即ちに中断されます。",
                    "restore_channels": "選択したチャンネルを復旧しますか？",
                    "destroy_channels": "選択したチャンネルを完全に削除しますか？",
                    "remove_broadcast": "選択した放送を削除しますか？?",
                    "remove_recording_file": "選択した録画ファイルを削除しますか？",
                    "update_stream_key": "Creatorストリームキーを変更しますか？",
                    "start_duplicate_recording_file": "手動録画を開始しますか？",
                    "stop_duplicate_recording_file": "手動録画を終了しますか？",
                    "duplicate_block_player_unregister": "再生デバイスの登録を解除しますか？",
                    "duplicate_block_player_register": "再生デバイスを登録しますか？",
                    "duplicate_block_player_reset": "全ての再生デバイスの登録を解除しますか？",
                    "block_user_limit_register": "該当ユーザーの視聴を制限しますか？",
                    "block_user_no_limit_register": "該当ユーザーの視聴制限を解除しますか？",
                    "remove_program_file": "選択したファイルを削除しますか？",
                    "cancel_upload_file": "アップロードを取り消しますか？",
                    "remove_program": "選択したプログラムを削除しますか？",
                    "disable_channel_status": "チャンネルを無効化するとライブ放送を視聴出来なくなります。このチャンネルを無効化しますか？",
                    "enable_channel_status": "チャンネルを有効化するとライブ放送を視聴できる状態になります。このチャンネルを有効化しますか？"
                },
                "error": {
                    "create": "生成に失敗しました。",
                    "update": "更新に失敗しました。",
                    "change": "変更に失敗しました。",
                    "remove": "削除できません。",
                    "hide_channels": "チャンネル非表示に失敗しました。",
                    "restore_channels": "チャンネル表示に失敗しました。",
                    "destroy_channels": "チャンネル削除に失敗しました。",
                    "channel_info": "チャンネル情報取得に失敗しました。",
                    "channel_encoding_info": "エンコーディング情報の取得に失敗しました。",
                    "exceed_maximum_creator_count": "Creator生成は最大3人まで可能です。",
                    "update_creator_info": "Creator情報更新に失敗しました。",
                    "reload_creator_stream_key": "Creator Stream keyの更新に失敗しました。",
                    "remove_file": "ファイル削除に失敗しました。",
                    "update_statistics": "統計情報の取得に失敗しました。",
                    "remove_broadcast": "放送の削除に失敗しました。",
                    "remove_recording_file": "録画ファイルの削除に失敗しました。",
                    "upload": "ファイルのアップロードに失敗しました。",
                    "create_creator": "Creatorの生成ができません。",
                    "remove_creator": "Creatorの削除に失敗しました。",
                    "remove_creator_onair": "放送中のCreatorは削除できません。",
                    "exist_in_blocks": "既に制限リストに追加されています。",
                    "exist_in_allows": "既に許可リストに追加されています。",
                    "remove_country": "国の削除に失敗しました。",
                    "empty_country": "追加する国を選択してください。",
                    "google_auth": "Googleアカウントの認証に失敗しました。",
                    "logout_google_auth": "Googleアカウントの削除に失敗しました。",
                    "check_login_right": "権限を確認してください。",
                    "duplicate_recording_not_on_air": "配信中に使用できます。",
                    "duplicate_recording_cannot_stop": "録画していないため、終了できません。",
                    "duplicate_block_player_unregister": "再生デバイスの登録を解除することに失敗しました。",
                    "duplicate_block_player_reset": "全ての再生デバイスの登録を解除することに失敗しました。",
                    "remove_program_file_ready_schedule": "この予定に編成されているプログラムがあるため削除できません。",
                    "remove_program_file": "ファイルを削除することができません。",
                    "remove_program_done_schedule": "完了した編成が含まれているためプログラムを削除することができません。",
                    "remove_program": "プログラムを削除することができません。",
                    "disable_channel_status": "チャンネルの無効化に失敗しました。",
                    "enable_channel_status": "チャンネルの有効化に失敗しました。",
                    "clone_channel": "チャンネルのコピーに失敗しました。",
                    "exist_in_referer_domains": "既にドメインリストに含まれています。",
                    "empty_domain": "追加するドメインを入力してください。",
                    "empty_check_domains": "許可するドメインリストが存在しません。",
                    "empty_reject_domains": "遮断するドメインリストが存在しません。"
                }
            },
            "live_action_logs": {
                "user_login": "ユーザーログイン完了",
                "creator_login": "Creatorログイン完了",
                "channel_created": "チャンネル登録完了",
                "channel_updated": "チャンネル更新完了",
                "channel_restored": "チャンネル表示完了",
                "channel_trashed": "チャンネル非表示完了",
                "channel_deleted": "チャンネル削除完了",
                "broadcast_started": "ライブ放送開始",
                "broadcast_paused": "ライブ放送一時停止",
                "broadcast_resumed": "ライブ放送再開",
                "broadcast_stopped": "ライブ放送中止",
                "country_restriction_created": "国別アクセス制限を追加",
                "country_restriction_deleted": "国別アクセス制限を除外",
                "file_transfer_created": "録画ファイルの転送ポリシーを追加",
                "file_transfer_updated": "録画ファイル転送ポリシーを更新",
                "file_transfer_deleted": "録画ファイル転送ポリシーを削除",
                "file_transfer_enabled": "録画ファイル転送ポリシーを有効化",
                "file_transfer_disabled": "録画ファイル転送ポリシーを無効化",
                "syndication_created": "シンジケーションを追加",
                "syndication_updated": "シンジケーションを更新",
                "syndication_deleted": "シンジケーションを削除",
                "syndication_enabled": "シンジケーションを有効化",
                "syndication_disabled": "シンジケーションを無効化",
                "content_provider_updated": "サービスアカウント更新完了",
                "recording_file_download": "録画ファイルをダウンロードする",
                "statistics_channel_download": "チャンネル統計をダウンロードする",
                "statistics_viewer_environment_download": "視聴者環境統計をダウンロードする",
                "statistics_storage_usage_download": "録画ファイル利用統計をダウンロードする",
                "statistics_service_usage_download": "録画ファイル利用統計をダウンロードする",
                "statistics_service_log_download": "サービスログをダウンロードする",
                "creator_updated": "Creator更新完了",
                "creator_created": "Creator登録完了",
                "creator_deleted": "Creator削除完了",
                "duplicate_recording_file_save_started": " 録画ファイルの手動保存を開始",
                "duplicate_recording_file_save_stopped": " 録画ファイルの手動保存を終了",
                "media_content_deleted": "プログラムファイル削除",
                "media_content_upload_prepared": "プログラムファイルアップロード準備",
                "program_created": "プログラム登録",
                "program_updated": "プログラム更新",
                "program_deleted": "プログラム削除",
                "statistics_service_usage_new_download": "サービス利用統計ダウンロード",
                "chatting_file_download": "チャットファイルダウンロード",
                "channel_enabled": "チャンネルを有効化する。",
                "channel_disabled": "チャンネルを無効化する。",
                "chatting_statistics_usage_download": "チャット使用履歴のダウンロード",
                "chatting_statistics_users_download": "チャット接続履歴のダウンロード",
                "chatting_statistics_messages_download": "チャットメッセージ履歴のダウンロード"
            },
            "please_select": "選択してください。",
            "remote_path_desc": "Remote_path",
            "file_transfer_tip1": "録画ファイルを自動転送する転送先を登録します。",
            "file_transfer_tip2": "登録された転送先に録画ファイルを転送します。最大%{count}個まで同時に使用することが可能です。",
            "file_transfer_max_count_tip": "録画ファイルの転送先は最大 {count} 個まで登録することができます。",
            "youtube_category_tip1": "Youtubeのカテゴリは1つ以上選択してからアップロードすることができます。",
            "youtube_category_tip2": "この設定はこのチャンネルからYoutubeにアップロードされる全てのコンテンツに適用されます。",
            "kollus_category_tip1": "Kollusカテゴリは1つ以上選択してからアップロードすることができます。",
            "kollus_category_tip2": "この設定はこのチャンネルからKollusにアップロードされる全てのコンテンツに適用されます。",
            "file_transfer_count_tip": "録画ファイルの転送先は最大 {count} 個まで登録することができます。",
            "please_google_auth": "Googleアカウントの認証を行ってください。",
            "loaded_youtube_category": "ファイルをアップロードするカテゴリを読み込みました。カテゴリを選択してください。",
            "syndication_max_count_tip": "シンジケーションは最大 {count} 個まで使用することができます。",
            "syndication_count_tip": "シンジケーションは最大 {count} 個まで登録することができます。",
            "syndication_tip1": "連携を行う外部プラットフォームのシンジケーション情報を入力します。連携されている状態では放送中のライブが追加された外部プラットフォームからも配信されます。",
            "syndication_tip2": "最大 {count}個まで同時に使用することが可能です。",
            "idle_screen_kind_poster": "このチャンネルの待ち受け画面は登録したポスターイメージです。",
            "idle_screen_kind_snapshot": "このチャンネルの待ち受け画面はライブ放送のスナップショットです。",
            "license_key_empty": "License Keyが存在しません。担当者に問い合わせください。",
            "downloadable_within_7_days": "ダウンロード可能な期限は7日以内となります。",
            "contract_tip1": "表示がある項目は追加課金です。",
            "contract_tip2": "その他の項目の設定を変更する場合には該当チャンネル別に設定を行ってください。",
            "placeholder_service_account_name": "サービスアカウント名を入力してください。",
            "members_empty": "ユーザー情報が存在しません。担当者に問い合わせください。",
            "creators_per_channels_manage_tip1": "チャンネル別のCreatorは実際にライブを行う人を指します。",
            "creators_per_channels_manage_tip2": "チャンネル別に設定されたCreatorコード及びストリームキー以外の情報ではライブ放送ができません。",
            "has_no_contract": "このサービスアカウントに締結された契約内容がありません。",
            "has_no_contract_detail": "Kollus Liveを利用するためにはKollus営業窓口にお問い合わせください。",
            "broadcast_update_callback_tip": "Callback URLにライブ放送を開始、中止、終了した場合各動作の情報を転送します。",
            "recording_file_transfer_callback_tip": "Callback URLに録画ファイルの転送結果を送ります。",
            "lms_callback_tip": "設定してURLにコンテンツ再生情報を転送します。httpsのみ対応します。",
            "placeholder_callback_url": "Callback URLを入力してください。",
            "recording_size_tip": "ライブ途中、録画ファイルの容量が4Gbを超過した場合、録画ファイルを自動保存",
            "recording_duration_tip1": "ライブ時間が",
            "recording_duration_tip2": "経過する度に、録画ファイルを自動保存",
            "division_delayed_tip1": "ライブストリーミング信号の断絶時間が",
            "division_delayed_tip2": "以内の場合、一放送で認識さ",
            "oauth_name_tip": "Something your users will recognize and trust.",
            "oauth_redirect_url_tip": "Your application's authorization callback URL.",
            "oauth_personal_access_token_desc": "Here is your new personal access token. This is the only time it will be shown so don't lose it! You may now use this token to make API requests.",
            "oauth_no_clients": "You have not created any OAuth clients.",
            "something_wrong": "問題が発生しました。再度お試しください。",
            "oauth_no_tokens": "You have not created any personal access tokens.",
            "oauth_no_authorized_applications": "You have not created any authorized application.",
            "duplicate_recording_tip1": "手動で録画ファイルを保存します。",
            "duplicate_recording_tip2": "ライブがOn-Airになると録画開始/終了ボタンが有効化され、ボタンを押してから実際に作動するまで最大5秒の遅延が発生する可能性があります。.",
            "duplicate_recording_tip3": "設定した録画自動保存機能はチャンネルを登録すると同時に適用されます。",
            "duplicate_recording_in_use": "ユーザー({username})が手動録画中のため、しばらくお待ちください。",
            "duplicate_recording_ing_tip": "2Mbps（ビットレート）で配信する場合、最大4時間まで録画ファイルとして保存できます。",
            "broadcast_update_callback_desc": "配信コールバックに使用されるパラメータの説明になります。",
            "recording_file_transfer_callback_desc": "録画ファイル転送パラメータのリストになります。",
            "chatting_exclusive_player_disable_desc1": "Security Playerの場合、チャットの使用が出来ません。",
            "chatting_exclusive_player_disable_desc2": "チャットを使用するためにはSecurity Playerの設定をoffにしてください。",
            "chatting_use_yes_no_tip": "該当チャンネルでのチャットの使用有無を設定します。",
            "chatting_type_tip": "エンベッドタイプは別途作業なしですぐ適用が可能です。開発タイプを使用するためには別途の契約が必要となります。",
            "chatting_type_embed_tip": "Chatrollを連係します。",
            "chatting_service_not_available": "サービスアカウント情報からChatrollの設定情報を追加してからご利用できます。",
            "placeholder_chatting_embed_code": "使用する場合、[HTML embed code]を入力してください。",
            "chatting_concurrent_user_tip1": "チャットの同時接続数に管理者/Creatorアカウントも含まれます。",
            "chatting_concurrent_user_tip2": "チャットに参加する場合、他の利用者より事前に参加してください。",
            "chatting_not_available_desc1": "チャットを使用するには別途契約が必要となります。",
            "chatting_not_available_desc2": "契約後にもチャットの利用ができない場合",
            "chatting_not_available_desc3": "チャンネル編集ページからチャット使用有無をOnにしてください。",
            "exceed_max_channel_count": "使用可能なチャンネル数の制限に到達しました。管理者にお問い合わせください。",
            "duplicate_block_policy_unavailable": "重複再生遮断ポリシーの制限により使用できません。",
            "placeholder_search_client_user_id": "ユーザーIDを入力してください。",
            "catting_available_at_html5": "チャットはHTML5 Playerのみ対応しています。",
            "program_placeholder_title": "プログラムタイトルを入力してください。",
            "recently_ordered_files": "直近で追加されたファイル",
            "program_file_search": "ファイル検索",
            "broadcast_duration_desc": "ファイル追加する度に自動計算で増加",
            "program_already_reserved_schedule": "既に予約された他のライブ放送と時間帯が重なっています。",
            "program_cannot_destroy_ongoing_or_finished": "終了したライブまたは進行中のプログラムは削除することができません。",
            "program_file_uploaded": "{file_name}のアップロードが完了されました。登録完了後ファイルリストに追加されます。",
            "program_file_upload_only_mp4": "mp4ファイルのみアップロードできます。",
            "program_select_channel": "チャンネルを選択してからプログラムを登録してください。",
            "program_select_start_date": "開始日を選択してください。",
            "chatting_profile_photo_tip_1": "プロファイルイメージを登録しないユーザーに適用するデフォルトイメージを変更します。",
            "chatting_profile_photo_tip_2": "横 %{maxWidth}px, 縦 %{maxHeight}px 以下のサイズのイメージファイルを登録してください。",
            "play_callback_tip": "設定したURLにkollus security playerの再生情報を転送します。",
            "program_file_upload_desc1": "トランスコーディングを有効化するとファイルの変換作業に時間を要することになりますが、安定性を求める場合には有効化することを推奨します。",
            "program_file_upload_desc2": "トランスコーディングをOffにする場合,",
            "program_file_upload_desc3": "オーディオのSample rateは 48khzに設定してください。",
            "program_file_upload_desc4": "オーディオ/ビデオのフォーマットが一致するように設定してください。",
            "program_wait_file_search": "待ち受け画面検索",
            "program_wait_file_upload_only": "jpgまたはpng形式のみ対応します。横 %{maxWidth}px, 縦 %{maxHeight}px 以下のサイズのみ対応します。 ",
            "program_wait_file_duration_min": "待ち受け画面の表示時間を入力してください。表示時間は360分以内で設定可能です。",
            "program_check_audio_format_error": "オーディオフォーマットが異なるためオーディオのシンクが合わない可能性があります。トランスコーディングしてから使用してください。",
            "program_check_video_format_warning": "ビデオフォーマットが異なるためシンジケーションを含む機能に誤作動が起きる可能性があります。このまま登録しますか？",
            "program_can_register_after_5min": "プログラム編成は現時刻から5分以降の時点から登録することが出来ます。",
            "program_file_please_register": "プログラムで使用するファイルを登録してください。",
            "channel_cannot_change_kind_program_to_general": "予約されたプログラムがあるためチャンネルタイプを変更することができません。",
            "file_not_exist_for_download": "ダウンロード可能なファイルがありません。",
            "chatting_admin_id_tooltip": "チャット管理者は jwtの client_user_id(cuuid)項目に入力した内容が基準になります。空白（スペース）で区分して入力してください。",
            "chatting_disabled_when_use_anonymous": "匿名チャットを使用している場合、プロファイルイメージを設定することはできません。",
            "chatting_profile_photo_cannot_disable_when_not_display_profile_photo": "プロファイルイメージを表示しない場合、基本プロファイルイメージを変更することはできません。",
            "chatting_profile_photo_cannot_upload_when_not_disable_profile_photo": "基本プロファイルイメージを使用する場合、プロファイルイメージを変更することはできません。",
            "chatting_scalable_tip": "チャットユーザーの規模が3,000人を超えると見込まれる場合、大規模チャットを有効化してください。",
            "chatting_send_status_tip": "チャットSDKを使用している場合のみ有効化してください。",
            "chatting_restart_broadcast_to_apply": "チャット管理者ID以外の項目の場合、放送を停止し、再開した時点に適用されます。",
            "referer_check_tip_1": "特定ドメインでライブストリームの再生を許可または遮断する設定を行う場合、ドメインを入力してください。複数のドメインを入力する場合には\",\"で区別してください。",
            "referer_check_tip_2": "ワイルドカードなど、文字列の特定部分を許可する場合には \"#\"を使用してください。",
            "referer_check_tip_3": "(例: 'abcd.com,go.abcd.com,aa.abcd.com' を登録する場合、#abcd.comを使用)",
            "referer_check_domain_rule": "({domain})このドメインは正しい形式ではありません。",
            "chatting_statistics_tip": "チャットの利用履歴はライブが終了してから30分後に表示されます。",
            "statistics_timezone_tip": "統計データの時間帯はUTC(GMT +00{00})となります。",
            "latency_config_check_integer_gte_0": "{attribute}には0以上の定数を入力してください。",
            "latency_config_check_integer_gte_1": "{attribute}には1以上の定数を入力してください。",
            "profile_type_match_tip": "プロファイルタイプは、エンコーディングプロファイルグループのタイプと一致しなければなりません。",
            "program_wait_file_upload_only_desc": "待機画面用のファイルはjpgまたはpngファイルのみアップロード可能です。 <br>横％縦％以下の画像ファイルを登録してください。",
            "not_use_filelive": "録画放送ポリシーは使用しません。",
            "not_use_webrtc": "WebRTCポリシーは使用しません。",
            "not_use_contract": "該当ポリシーは使用しません。",
            "profile_group_type_match_tip": "エンコーディングプロファイルクループのタイプとチャンネルのタイプが一致しなければなりません。",
            "program_same_audio_codec_and_sample_rate": "同じオーディオコデックとサンプルレートでしか修正できません。",
            "program_conflicting_schedule": "プログラムのスケジュールが重複してます。",
            "program_wait_file_duration_min_max": "最大360分まで設定可能です。",
            "program_register_modal_title_placeholder": "プログラムタイトルを入力してください。",
            "program_register_modal_contents_info": "同じオーディオコデックとサンプルレートでしか修正できません。",
            "program_title_required": "プログラムのタイトル入力は必須です。",
            "program_channel_required": "チャンネル選択は必須です。",
            "program_wait_content_duration_over_zero": "最大360分まで設定可能です。<BR>待機画面継続時間は1時間以上の定数で入力してください。",
            "program_content_file_required": "コンテンツ選択は必須です。同じオーディオコデックとサンプルレートでしか修正できません。",
            "program_check_video_format_error": "ビデオフォーマットが異なります。この場合サービスにエラーが発生する可能性があります。",
            "program_hide_channel_notification": "非活性チャンネルはライブ配信できません。",
            "schedule_live_on_modify_error": "ライブ中のプログラムは修正できません。",
            "schedule_live_end_modify_error": "ライブが終了したプログラムは修正できません。",
            "schedule_live_modify_success": "ライブスケジュールを変更しました。",
            "schedule_live_modify_fail": "ライブスケジュール変更に失敗しました。",
            "schedule_copy_warning": "修正した情報を保存し、コピーしますか、キャンセル時変更内容が削除されます。",
            "schedule_modal_close_warning": "入力した情報が保存されておりません。終了しますか。",
            "schedule_modal_close_modified_save": "修正した情報を保存しますか。",
            "program_check_video_format_each_contents": "コンテンツの間にfail_formatが異なります。",
            "program_check_audio_format_each_contents": "コンテンツの間にfail_formatが異なります。",
            "program_check_video_format_between_contents_and_wait": "コンテンツと待ち受け画面の間にfail_formatが異なります。",
            "program_check_audio_format_between_contents_and_wait": "コンテンツと待ち受け画面の間にfail_formatが異なります。",
            "program_check_video_format_confirm": "選択したファイルのfail_formatが異なります。この場合、ファイル変更時にエラーが発生する可能性があります。このまま登録しますか？",
            "no_contents_list": "検索結果がありません。",
            "program_select_channel_placeholder": "チャンネルを選択してください。",
            "program_contents_search": "コンテンツ検索",
            "program_have_none_transcoding_done_files": "トランスコーディングが完了されたコンテンツのみプログラム登録が可能です。",
            "program_wait_file_upload_wrong_format": "ファイル名に ~&()\\|/?<>'\";:`% が含まれた場合、使用できません。",
            "program_upload_fail_error": "ネットワークの接続が不安定となります。ご確認後、改めてアップロードしてください。",
            "not_use_cmaf": "CMAFを使用しない",
            "not_use_aes128": "ご利用を希望される場合は、技術担当者（jp_team@catenoid.net）までお問い合わせください。",
            "block_external_output_display_desc": "モバイル端末のTV-OUT出力やPC（Windows）からのプロジェクター出力を遮断します。",
            "block_angle_brackets": "山括弧（＜、＞）は入力できません。",
            "invalid_service_account_input": "サービスアカウントには絵文字(Emoji)及び山括弧（＜、＞）は入力できません。"
        },
        "pagination": {
            "previous": "&laquo; 前",
            "next": "次 &raquo;"
        },
        "words": {
            "login": "ログイン",
            "logout": "ログアウト",
            "login_account": "ログインアカウント",
            "has_not_service_account": "サービスアカウントが存在しません",
            "role": "役割",
            "timezone": "タイムゾーン",
            "language": "言語",
            "broadcast": "放送",
            "broadcasts": "放送",
            "live": "ライブ放送",
            "filesize": "ファイルサイズ",
            "list": "リスト",
            "channel": "チャンネル",
            "channels": "チャンネル",
            "all_broadcasts": "全ての放送",
            "all_channels": "全てのチャンネル",
            "live_onair": "放送中",
            "email": "メール",
            "email_address": "メールアドレス",
            "password": "パスワード",
            "remember_me": "アカウント保存",
            "select_all": "全て選択",
            "key": "キー",
            "preview": "プレビュー",
            "visitor_counts": "アクセス数",
            "name": "名前",
            "count": "回数",
            "title": "タイトル",
            "customer_code": "顧客コード",
            "all": "全て",
            "open": "公開",
            "restore": "表示",
            "not_open": "非公開",
            "live_status": "放送状態",
            "live_status_on": "放送中",
            "live_status_off": "放送終了",
            "shared_status": "公開有無",
            "shared_status_on": "公開",
            "shared_status_off": "非公開",
            "channel_manage": "チャンネル管理",
            "channel_list": "チャンネルリスト",
            "hidden_channel_list": "非表示リスト",
            "recording_files": "録画ファイルリスト",
            "creator": "Creator",
            "decoration": "ロゴ/ポスター/スナップショット",
            "statistics_manage": "統計管理",
            "statistics": "統計",
            "statistics_channel": "チャンネル統計",
            "statistics_viewer_env": "視聴者環境統計",
            "storage_usage": "録画ファイル利用統計",
            "service_logs": "サービスログ",
            "preference": "設定",
            "general": "一般",
            "basic_info": "基本情報",
            "profile": "プロファイル",
            "members": "Members",
            "close": "閉じる",
            "go_detail": "詳細",
            "datetime": "日付",
            "save": "保存",
            "cancel": "取消",
            "add": "追加",
            "upload": "アップロード",
            "copy": "コピー",
            "search": "検索",
            "use_yes": "使用する",
            "use_no": "使用しない",
            "remove": "削除",
            "logo": "ロゴ",
            "idle_screen_kind": "待機画面設定",
            "poster": "ポスター",
            "snapshot": "スナップショット",
            "started_at": "開始時刻",
            "ended_at": "終了時刻",
            "broadcast_interval": "放送時間",
            "live_counts": "ライブ回数",
            "concurrently_viewer_limit": "同時視聴者数制限",
            "latest_live_broadcast": "最近のライブ放送",
            "title_and_creator": "タイトル / Creator",
            "started_and_ended": "開始時刻 / 終了時刻",
            "accumulate_viewers": "視聴者数累計",
            "hidden_date": "非表示状態にした日付",
            "profile_group_name": "プロファイルグループ名",
            "profile_selected_name": "種類",
            "profile_group_screen_type": "タイプ",
            "media_profile_groups": "エンコーディングプロファイル",
            "is_shared": "公開有無",
            "use_duplicate_block": "重複再生遮断",
            "meta_title_pattern": "メタ情報タイトル",
            "meta_description": "メタ情報内容",
            "recording_file_pattern": "録画ファイル名生成ポリシー",
            "recording_file_policy": "録画ファイル保存ポリシー",
            "use_capture_block": "録画/キャプチャ防止",
            "use_exclusive_player": "Kollus security player",
            "use_timeshift": "Timeshift",
            "creator_nickname": "Creatorニックネーム",
            "creator_code": "Creatorコード",
            "creator_stream_key": "Creatorストリームキー",
            "create_channel": "チャンネル登録",
            "edit_channel": "チャンネル編集",
            "hide_channels": "チャンネル非表示",
            "remove_channels": "チャンネル削除",
            "restore_channels": "チャンネル表示",
            "remove_recording_files": "録画ファイル削除",
            "remove_broadcasts": "放送削除",
            "broadcast_list": "放送リスト",
            "today": "今日",
            "store": "保存",
            "edit": "編集",
            "description": "内容",
            "video_gateway_link": "VideoGatewayリンク",
            "channel_key": "チャンネルキー",
            "link": "リンク",
            "application": "アプリケーション",
            "stream_key": "ストリームキー",
            "show": "見る",
            "delete": "削除",
            "detail_information": "詳細情報",
            "creator_information": "Creator詳細情報",
            "all_creators": "全てのCreator",
            "onair_creator": "放送中のCreator",
            "broardcast_ip_address": "送出IP",
            "broadcast_started_at": "送出時刻",
            "broadcast_location": "送出地域",
            "recording_file_created_volume": "録画ファイル生成容量",
            "live_count": "ライブ回数",
            "statistics_download": "統計ダウンロード",
            "statistics_storage_usage": "録画ファイル利用統計",
            "statistics_service_logs": "サービスログ",
            "action_datetime": "作業日時",
            "division": "区分",
            "action_user": "作業者",
            "subject_name": "対象",
            "action_message": "作業内容",
            "user_login": "管理者ログイン",
            "creator_login": "Creatorログイン",
            "channel_created": "チャンネル生成",
            "channel_updated": "チャンネル更新",
            "channel_restored": "チャンネル表示",
            "channel_trashed": "チャンネル非表示",
            "channel_deleted": "チャンネル削除",
            "broadcast_started": "ライブ放送開始",
            "broadcast_paused": "ライブ放送一時停止",
            "broadcast_resumed": "ライブ放送再開",
            "broadcast_stopped": "ライブ放送中止",
            "no_limit": "無制限",
            "period_today": "本日",
            "period_3d": "3日",
            "period_7d": "7日",
            "period_30d": "30日",
            "previous": "Previous",
            "next": "Next",
            "watch_time": "視聴時間",
            "max_acc_user": "累積視聴者数",
            "total_acc_user": "ユニーク視聴者数",
            "max_cur_user": "最大同時視聴者数",
            "total_visit_count": "アクセス数",
            "total_broadcast_interval": "全体放送時間",
            "average_broadcast_interval": "平均放送時間",
            "total_watch_time": "全体視聴時間",
            "average_watch_time": "平均視聴時間",
            "watch_user": "視聴者数",
            "visit_count": "アクセス数",
            "traffic": "トラフィック",
            "transfer": "転送量",
            "response_code": "Response code",
            "country": "国別",
            "domainOrUrl": "ドメイン/URL別",
            "device": "デバイス別",
            "os": "OS別",
            "browser": "ブラウザ別",
            "channel_name": "チャンネル名",
            "live_name": "ライブ名",
            "acc_user_count": "累計ユニーク視聴者数",
            "cur_user_count": "リアルタイム同時視聴者数",
            "request_count": "アクセス数",
            "response_code_1xx_desc": "1xx(条件付きレスポンス)",
            "response_code_2xx_desc": "2xx(成功)",
            "response_code_3xx_desc": "3xx(リダイレクト完了)",
            "response_code_4xx_desc": "4xx(リクエストエラー)",
            "response_code_5xx_desc": "5xx(サーバーエラー)",
            "unit_user_count": "人",
            "unit_request_count": "件",
            "live_info": "ライブ情報",
            "channel_info": "チャンネル情報",
            "live_title": "ライブタイトル",
            "remove_recording_file": "録画ファイル削除",
            "kollus_live_cms": "Kollus LIVE",
            "quality": "品質",
            "video": "ビデオ",
            "audio": "オーディオ",
            "use_yes_no": "使用有無",
            "codec": "コーデック",
            "resolution": "解像度",
            "bitrate": "ビットレート",
            "media_player_policy_none": "なし",
            "media_player_policy_only": "Kollus security player",
            "media_player_policy_only_at_mobile": "モバイル Kollus security player",
            "country_restriction": "国別アクセス制御",
            "allowed_country": "許可国",
            "blocked_country": "制限国",
            "allowed_country_select": "許可国選択",
            "blocked_country_select": "制限国選択",
            "recording_file_transfer": "録画ファイル転送",
            "register": "登録",
            "file_transfer_kind": "ファイル転送先",
            "category": "カテゴリ",
            "youtube_upload_open": "Youtubeアップロード公開",
            "authentication": "認証",
            "aws_bucket_name_desc": "S3バケット名",
            "aws_access_key_id_desc": "AWS S3 access key 情報",
            "aws_secret_access_key_desc": "AWS S3 secret access key 情報",
            "use_encryption": "encryption使用有無",
            "google_auth_go": "Googleアカウント認証",
            "platform_name": "プラットフォーム名",
            "syndication": "シンジケーション",
            "category_key": "カテゴリキー",
            "contract_info": "契約情報",
            "service_account": "サービスアカウント",
            "service_account_name": "サービスアカウント名",
            "service_account_key": "サービスアカウントキー",
            "member_manage": "ユーザー管理",
            "service_duration": "サービス開始日 ~ 終了日",
            "service_type": "サービスタイプ",
            "contract_channel_count": "契約チャンネル数",
            "max_birate": "最大ビットレート",
            "player": "Player",
            "forwarding_target_limit_count": "転送先制限数",
            "license_key": "ライセンスキー",
            "platform": "プラットフォーム",
            "event": "イベント",
            "mobile_encoder_sdk": "モバイルエンコーダーSDK",
            "create_date": "生成日",
            "expire_date": "終了日",
            "package_name/bundle_id": "Package name/Bundle ID",
            "authentication_key": "認証キー",
            "ios": "iOS",
            "android": "Android",
            "content_provider_updated": "サービスアカウント更新",
            "login_info": "ログイン情報",
            "user_info": "ユーザー情報",
            "manage": "管理",
            "role_owner": "最高管理者",
            "role_manager": "管理者",
            "role_viewer": "運用者",
            "role_creator": "Creator",
            "menu": "メニュー",
            "detail_function": "詳細機能",
            "view": "見る",
            "modify": "編集",
            "channel_edit": "チャンネル編集",
            "channel_hide/restore": "チャンネル非表示/表示（放送中止）",
            "channel_detail": "チャンネル詳細",
            "mnu_live": "ライブ",
            "recording_file_download": "録画ファイルダウンロード",
            "recording_file_remove": "録画削除",
            "live_info_desc": "ライブ情報 （タイトル、説明、ポスター、シンジケーション）",
            "kollus_live_role_guide": "Kollus live 権限ガイド",
            "creators_per_channels_manage": "チャンネル別 Creator 管理",
            "download": "ダウンロード",
            "security_key": "セキュリティキー",
            "custom_key": "ユーザーキー",
            "callback": "callback",
            "broadcast_update_callback": "live callback",
            "broadcast_update_callback_url": "live callback URL",
            "recording_file_transfer_callback": "録画ファイル転送callback",
            "recording_file_transfer_callback_url": "録画ファイル転送callback URL",
            "lms_callback": "LMS CallBack",
            "lms_callback_url": "LMS CallBack URL",
            "live_broadcast_policy": "ライブ放送ポリシー",
            "save_maximum_volume": "最大容量に到達した時に自動保存",
            "save_interval_time": "インターバルタイムを指定して区間別保存",
            "unit_minute": "分",
            "recording_file_policy_save_no_file": "ファイル保存なし",
            "recording_file_policy_save_auto_file": "ファイル自動保存",
            "recording_file_policy_save_manual_file": "ファイル手動保存",
            "recording_file_policy_save_all_file": "ファイル自動 & 手動保存",
            "save_auto": "自動保存",
            "save_manual": "手動保存",
            "oauth_clients": "OAuth Clients",
            "personal_access_tokens": "Personal Access Tokens",
            "client_id": "Client ID",
            "secret": "Secret",
            "create_new_client": "Create New Client",
            "create_new_token": "Create New Token",
            "redirect_url": "Redirect URL",
            "scopes": "Scopes",
            "create_client": "Create Client",
            "edit_client": "Edit Client",
            "go_kollus_live_api": "Kollus Live API",
            "create_token": "Create Token",
            "personal_access_token": "Personal Access Token",
            "authorized_applications": "Authorized Applications",
            "statistics_channel_download": "チャンネル統計ダウンロード",
            "statistics_viewer_env_download": "視聴者環境統計ダウンロード",
            "statistics_storage_usage_download": "録画ファイル利用統計ダウンロード",
            "statistics_service_usage_download": "録画ファイル利用統計ダウンロード",
            "statistics_service_log_download": "サービスログダウンロード",
            "recording_started_at": "録画開始時刻",
            "recording_ended_at": "録画終了時刻",
            "recording_type": "録画タイプ",
            "play_now": "再生",
            "recording_download": "録画ファイルダウンロード",
            "auto": "自動",
            "manual": "手動",
            "recording_start": "録画開始",
            "recording_stop": "録画終了",
            "duplicate_recording_start": "手動録画開始",
            "duplicate_recording_stop": "手動録画終了",
            "duplicate_recording_ing": "手動録画中",
            "broadcast_key": "ライブ放送キー",
            "stream_start": "配信開始",
            "stream_stop": "配信停止",
            "stream_pause": "配信再開ポリシーによる設定時間内の配信停止",
            "stream_resume": "配信再開ポリシーによる設定時間内の配信再開",
            "recording_file_name": "録画ファイル名",
            "recording_file_kind": "録画ファイル種類. segment: 自動録画 duplicate: 手動録画",
            "recording_file_transfer_result": "転送結果. 0: 失敗 1: 成功",
            "chatting": "チャット",
            "chatting_use_yes_no": "チャット使用有無",
            "chatting_type": "チャットタイプ",
            "chatting_type_embed": "エンベッドタイプ",
            "catting_go_chatroll_config": "Chatroll設定に移動",
            "chatting_position": "チャットウィンドウの位置",
            "top": "上",
            "bottom": "下",
            "right": "右",
            "left": "左",
            "type": "タイプ",
            "auto_recording_files_viewer": "自動録画ファイル再生",
            "manual_recording_files_viewer": "手動録画ファイル再生",
            "auto_recording_file": "自動録画ファイル",
            "manual_recording_file": "手動録画ファイル",
            "auto_recording": "自動録画",
            "manual_recording": "手動録画",
            "help_center": "サポートセンター",
            "aws_region_key_desc": "AWS S3 region key 情報",
            "password_change": "パスワード変更",
            "old_password": "現在のパスワード",
            "new_password": "新規パスワード",
            "password_confirm": "パスワード（確認用）",
            "video_gateway": "ビデオゲートウェイ",
            "show_channel_title_at_vg": "チャンネルタイトル表示",
            "show_broadcast_title_at_vg": "ライブタイトル表示",
            "show_meta_description_at_vg": "メタ情報内容表示",
            "duplicate_block": "重複再生遮断",
            "duplicate_block_manage": "重複再生ブロックの管理",
            "duplicate_block_sessions": "再生中のセッション",
            "duplicate_block_logs": "重複再生ブロック・ログ",
            "player_id": "プレーヤーID",
            "client_user_id": "ユーザＩＤ",
            "session_unregister": "セッション終了",
            "duplicate_block_policy": "一度に一つの端末からのみ再生可能",
            "duplicate_block_policy_allow_one_device_at_same_time": "一度に一つの端末からのみ再生可能",
            "duplicate_block_policy_allow_registered_device": "事前に登録された端末からのみアクセスを許可(数の指定)",
            "duplicate_block_policy_allow_registered_one_device_at_same_time": "事前に登録された(複数の)端末の中、一つの端末からのみアクセスを許可(数の指定)",
            "duplicate_block_reset_all_player_id": "全ての再生端末ブロック解除",
            "duplicate_block_delete_player_id": "再生デバイスの登録を解除",
            "duplicate_block_delete_client_user_id": "ユーザーIDの登録を解除",
            "reset": "初期化",
            "player_id_register": "プレーヤーIDの登録",
            "created_at": "登録日",
            "capture_block_policy": "キャプチャ遮断ポリシー",
            "capture_block_policy_stop_playback_and_alert_warning": "再生中止及び警告処理をする",
            "capture_block_policy_stop_playback_alert_warning_and_restrict_user_content_access": "再生中止及び警告処理&該当ユーザーからのアクセスを制限する",
            "capture_block_policy_use_teruten": "Teruten",
            "capture_block_policy_use_teruten_stop_playback_and_alert_warning": "再生中止及び警告処理をする + Teruten",
            "capture_block_policy_use_teruten_block_process": "Teruten + 録画プロセス遮断",
            "capture_block_policy_block_process": "キャプチャ遮断",
            "capture_block": "キャプチャ遮断",
            "capture_block_logs": "キャプチャ遮断履歴",
            "used_capture_tool": "使用されたキャプチャツール",
            "player_kmpi": "iOS専用プレーヤー",
            "player_kmpa": "",
            "player_mac": "Mac専用プレーヤー",
            "player_knp": "PC Netscape plug in player(ChromeFirefox)",
            "player_kap": "PC ActiveX plug in player(IE)",
            "player_kag": "Kollus agent player",
            "player_type": "player type",
            "player_block": "制限",
            "player_unblock": "制限解除",
            "block_user_list": "制限されたユーザリスト",
            "hardware_id": "ハードウェアID",
            "general_channel": "一般チャンネル",
            "program_channel": "編成チャンネル",
            "file_list": "ファイルリスト",
            "program_schedule": "プログラム編成",
            "file_name": "ファイル名",
            "file_size": "ファイルサイズ",
            "play_time": "再生時間",
            "upload_time": "アップロード時間",
            "program_count_finished": "編成回数（完了）",
            "program_count_ready": "編成回数（予定）",
            "program_manage": "編成管理",
            "file_register": "ファイル登録",
            "program_register": "プログラム予約",
            "program_modify": "プログラム編集",
            "no_title": "タイトル無し",
            "file": "ファイル",
            "total_broadcast_time": "総放送時間",
            "broadcast_start_date": "放送開始日",
            "channel_kind": "チャンネルタイプ",
            "program_created": "プログラム登録",
            "program_updated": "プログラム更新",
            "program_deleted": "プログラム削除",
            "media_content_deleted": "プログラムファイル削除",
            "media_content_upload_prepared": "プログラムファイルアップロード準備",
            "transcoding_on": "トランスコーディング中",
            "transcoding_error": "トランスコーディングエラー",
            "include_removed_channels": "削除されたチャンネルを含む",
            "chatting_limit_count": "1分間転送可能なメッセージ数の上限",
            "chatting_join_message": "ユーザ歓迎メッセージ",
            "chatting_profile_photo": "プロファイル写真",
            "chatting_profile_photo_display": "プロファイルイメージ表示",
            "chatting_profile_default_photo_change": "プロファイルのデフォルトイメージを変更",
            "play_callback": "再生Callback",
            "play_callback_url": "再生Callback URL",
            "transcoding": "トランスコーディング",
            "status": "状態",
            "use_possible": "使用可能",
            "register_wait": "登録待機",
            "register_fail": "登録失敗",
            "wait_media_content": "待ち受け画面",
            "wait_media_content_duration_m": "待ち受け画面表示時間",
            "program": "編成",
            "hide_channel": "非表示チャンネル",
            "statistics_service_usage": "サービス利用統計",
            "syndication_time": "シンジケーション時刻",
            "start_time": "開始時刻",
            "end_time": "終了時刻",
            "statistics_service_usage_new_download": "サービス利用統計ダウンロード",
            "chatting_anonymous_chat": "匿名チャット",
            "chatting_enable_block": "ユーザーブロック機能有効化",
            "chatting_download": "チャットダウンロード",
            "chatting_file_download": "チャットファイルダウンロード",
            "chatting_unique_user_count": "チャット参加人数",
            "chatting_sum_message_count": "チャットメッセージ件数",
            "chatting_admin_id": "チャット管理者ID",
            "vod_storage_statistics": "VOD ストレージ統計",
            "enable": "有効化",
            "disable": "無効化",
            "channel_enabled": "チャンネル有効化",
            "channel_disabled": "チャンネル無効化",
            "multi_drm": "Multi DRM",
            "widevine_revoked_device": "Widevine 認証失効機器",
            "allow_play": "再生許可",
            "block_play": "再生遮断",
            "chatting_download_fields": "ダウンロードする項目を指定",
            "concurrently_chatting_limit": "チャット参加者数制限",
            "chatting_download_file_type": "ダウンロードするファイルタイプ",
            "file_live": "File Live",
            "scalable_chatting": "大規模チャット",
            "webrtc_channel": "WebRTC チャンネル",
            "chatting_send_status": "いいね！",
            "chatting_usage_statistics": "チャット利用統計",
            "chatting_statistics_usage_download": "チャット利用統計ダウンロード",
            "chatting_unique_count": "チャット参加者数",
            "chatting_message_count": "チャットメッセージ件数",
            "average_chatting_unique_count": "平均チャット参加者数",
            "average_chatting_message_count": "平均チャットメッセージ件数",
            "referer_config": "リファラー設定",
            "referer_check_domains": "許可するドメインリスト",
            "referer_reject_domains": "遮断するドメインリスト",
            "referer_check_option_disable": "無効化",
            "referer_check_option_check": "特定ドメインのみ再生を許可",
            "referer_check_option_reject": "特定ドメインのみ再生を遮断",
            "domain": "ドメイン",
            "channel_clone": "チャンネルコピー",
            "profile_group_key": "プロファイルグループキー",
            "webrtc": "WebRTC",
            "realtime_live": "リアルタイム放送",
            "recording_live": "録画放送",
            "realtime": "リアルタイム",
            "recording": "録画",
            "latency_time_config": "遅延時間設定",
            "unit_second": "秒",
            "unit_quantity": "個",
            "size": "ファイルサイズ",
            "program_ready_time": "ライブ放送時間",
            "audio_codec": "オーディオコデック",
            "sample_rate": "サンプルレート",
            "frame_rate": "フレイムレート",
            "original": "原本",
            "tr": "トランスコーディング",
            "dont_delete_message": "放送予定があるためこちらの動画は削除できません。",
            "transcoding_fail": "トランスコーディング失敗",
            "contents_list": "コンテンツリスト",
            "wait_media_content_list": "待機画面リスト",
            "contents_register": "コンテンツアップロード",
            "wait_media_content_register": "待機画面アップロード",
            "upload_file_desc": "ファイルをドラッグアンドドロップするかブラウザからファイルを選択してください。",
            "upload_progress": "progress%アップロード完了",
            "upload_status_wait": "アップロード待機中",
            "upload_status_done": "アップロード成功",
            "upload_status_cancel": "アップロードキャンセル",
            "upload_status_fail": "アップロード失敗",
            "success_upload_clear": "生協したリストのクリア",
            "max_uploading_count_message": "同時アップロードは最大20個まで可能です。",
            "file_max_size_message": "ファイルサイズが2GB以上はアップロードできません。",
            "contents": "ビデオ",
            "recoding_channel": "録画チャンネル",
            "all_recoding_channel": "全体録画チャンネル",
            "program_live_status_live": "ライブ中",
            "program_live_status_end": "ライブ終了",
            "contents_name_search": "コンテンツの名前検索",
            "only_upload_success_contents_comments": "アップロード成功リスト",
            "admin_login": "Administrator ログイン",
            "upload_transcoding_desc_1_1": "トランスコーディング進行率はコンテンツリストメニューから確認可能です。",
            "upload_transcoding_desc_1_2": "トランスコーディングが完了されましたら、コンテンツリストかんらファイルサイズ、再生時間が確定されます。",
            "upload_transcoding_desc_2_1": "トランスコーディング進行率は待機画面リストメニューから確認可能です。",
            "upload_transcoding_desc_2_2": "トランスコーディングが完了されましたら、コンテンツリストかんらファイルサイズ、再生時間が確定されます。",
            "upload_transcoding_desc_2_3": "待ち受け画面は選択可否に関わらず自動トランスコーディングされます。",
            "program_title": "プログラムタイトル",
            "contents_select": "コンテンツ選択",
            "program_hide_channel_info": "非表示チャンネルのライブ放送はすぐに中断されます。",
            "max_age": "Max age",
            "chunk_duration": "Chunk duration",
            "chunk_count": "Chunk count",
            "complete_upload_clear": "完了した項目リスト",
            "transcoding_wait": "待機中",
            "max_fps": "最大 fps",
            "chatting_block_dup_nickname": "重複ニックネーム遮断",
            "cmaf": "低遅延ライブ",
            "programming_live": "疑似ライブ",
            "unit_millisecond": "ミリ秒",
            "chunk_part_duration_cmaf": "Chunk part duration",
            "channel_low_latency_hls": "低スペックデバイス向けHLS",
            "use_aes128": "AES-128",
            "channel_not_available": "利用不可",
            "block_external_output_display": "外部ディスプレイへの出力遮断"
        },
        "validation": {
            "accepted": "{attribute}を承認してください。",
            "active_url": "{attribute}は、有効なURLではありません。",
            "after": "{attribute}には、{date}以降の日付を指定してください。",
            "after_or_equal": "{attribute}には、{date}以降もしくは同日時を指定してください。",
            "alpha": "{attribute}には、アルファベッドのみ使用できます。",
            "alpha_dash": "{attribute}には、英数字('A-Z','a-z','0-9')とハイフンと下線('-','_')のみ入力可能です。",
            "alpha_num": "{attribute}には、英数字('A-Z','a-z','0-9')のみ入力可能です。",
            "array": "{attribute}には、配列を指定してください。",
            "before": "{attribute}には、{date}以前の日付を指定してください。",
            "before_or_equal": "{attribute}には、{date}以前もしくは同日時を指定してください。",
            "between": {
                "numeric": "{attribute}には、{min}から、{max}までの数字を指定してください。",
                "file": "{attribute}には、{min} KBから{max} KBまでのサイズのファイルを指定してください。",
                "string": "{attribute}は、{min}文字から{max}文字にしてください。",
                "array": "{attribute}の項目は、{min}個から{max}個にしてください。"
            },
            "boolean": "{attribute}には、'true'か'false'を指定してください。",
            "confirmed": "{attribute}と{attribute}が一致しません。",
            "date": "{attribute}は、正しい日付ではありません。",
            "date_format": "{attribute}の形式は、'{format}'に対応していません。",
            "different": "{attribute}と{other}には、異なるものを指定してください。",
            "digits": "{attribute}は、{digits}桁にしてください。",
            "digits_between": "{attribute}は、{min}桁から{max}桁にしてください。",
            "dimensions": "{attribute}は、正しい縦横比ではありません。",
            "distinct": "{attribute}に重複した値があります。",
            "email": "{attribute}は、有効なメールアドレス形式で指定してください。",
            "exists": "選択された{attribute}は、有効ではありません。",
            "file": "{attribute}はファイルのみ可能です。",
            "filled": "{attribute}は必須です。",
            "gt": {
                "numeric": "{attribute}は、{value}より大きくなければなりません。",
                "file": "{attribute}は、{value} KBより大きくなければなりません。",
                "string": "{attribute}は、{value}文字より大きくなければなりません。",
                "array": "{attribute}の項目数は、{value}個より大きくなければなりません。"
            },
            "gte": {
                "numeric": "{attribute}は、{value}以上でなければなりません。",
                "file": "{attribute}は、{value} KB以上でなければなりません。",
                "string": "{attribute}は、{value}文字以上でなければなりません。",
                "array": "{attribute}の項目数は、{value}個以上でなければなりません。"
            },
            "image": "{attribute}には、画像を指定してください。",
            "in": "選択された{attribute}は、有効ではありません。",
            "in_array": "{attribute}は、{other}に存在しません。",
            "integer": "{attribute}には、整数を指定してください。",
            "ip": "{attribute}には、有効なIPアドレスを指定してください。",
            "ipv4": "{attribute}はIPv4アドレスを指定してください。",
            "ipv6": "{attribute}はIPv6アドレスを指定してください。",
            "json": "{attribute}には、有効なJSON文字列を指定してください。",
            "lt": {
                "numeric": "{attribute}は、{value}より小さくなければなりません。",
                "file": "{attribute}は、{value} KBより小さくなければなりません。",
                "string": "{attribute}は、{value}文字より小さくなければなりません。",
                "array": "{attribute}の項目数は、{value}個より小さくなければなりません。"
            },
            "lte": {
                "numeric": "{attribute}は、{value}以下でなければなりません。",
                "file": "{attribute}は、{value} KB以下でなければなりません。",
                "string": "{attribute}は、{value}文字以下でなければなりません。",
                "array": "{attribute}の項目数は、{value}個以下でなければなりません。"
            },
            "max": {
                "numeric": "{attribute}には、{max}以下の数字を指定してください。",
                "file": "{attribute}には、{max} KB以下のファイルを指定してください。",
                "string": "{attribute}は、{max}文字以下にしてください。",
                "array": "{attribute}の項目は、{max}個以下にしてください。"
            },
            "mimes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "mimetypes": "{attribute}には、{values}タイプのファイルを指定してください。",
            "min": {
                "numeric": "{attribute}には、{min}以上の数字を指定してください。",
                "file": "{attribute}には、{min} KB以上のファイルを指定してください。",
                "string": "{attribute}は、{min}文字以上にしてください。",
                "array": "{attribute}の項目は、{max}個以上にしてください。"
            },
            "not_in": "選択された{attribute}は、有効ではありません。",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "{attribute}には、数字を指定してください。",
            "present": "{attribute}は、必ず存在しなければなりません。",
            "regex": "{attribute}には、有効な正規表現を指定してください。",
            "required": "{attribute}は、必ず指定してください。",
            "required_if": "{other}が{value}の場合、{attribute}を指定してください。",
            "required_unless": "{other}が{value}以外の場合、{attribute}を指定してください。",
            "required_with": "{values}が指定されている場合、{attribute}も指定してください。",
            "required_with_all": "{values}が全て指定されている場合、{attribute}も指定してください。",
            "required_without": "{values}が指定されていない場合、{attribute}を指定してください。",
            "required_without_all": "{values}が全て指定されていない場合、{attribute}を指定してください。",
            "same": "{attribute}と{other}が一致しません。",
            "size": {
                "numeric": "{attribute}には、{size}を指定してください。",
                "file": "{attribute}には、{size} KBのファイルを指定してください。",
                "string": "{attribute}は、{size}文字にしてください。",
                "array": "{attribute}の項目は、{size}個にしてください。"
            },
            "string": "{attribute}には、文字を指定してください。",
            "timezone": "{attribute}には、有効なタイムゾーンを指定してください。",
            "unique": "指定の{attribute}は既に使用されています。",
            "uploaded": "{attribute}のアップロードに失敗しました。",
            "url": "{attribute}は、有効なURL形式で指定してください。",
            "uuid": "The {attribute} must be a valid UUID.",
            "lower_enum_key": "選択された{attribute}は、有効ではありません。",
            "optimus_exists": "選択された{attribute}は、有効ではありません。",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "https_url": "{attribute}はhttps URLを入力してください。",
                "ip_port": "{attribute}はip{port}を入力してください。"
            },
            "no_emoji": "絵文字の入力はできません。",
            "no_angle_brackets": "山括弧（＜、＞）は入力できません。",
            "attributes": {
                "meta_title_pattern": "メタ情報タイトル",
                "meta_description": "メタ情報内容",
                "title": "タイトル",
                "upload_file": "アップロードファイル",
                "customer_code": "顧客コード",
                "editor_title": "タイトル",
                "category": "カテゴリ",
                "link": "リンク",
                "stream_name": "ストリームキー",
                "category_key": "カテゴリキー",
                "old_password": "現在のパスワード",
                "new_password": "新規パスワード",
                "password_confirm": "パスワード（確認用）",
                "chunk_count_cmaf": "chunk count",
                "chunk_duration_cmaf": "chunk duration",
                "chunk_part_duration_cmaf": "chunk part duration"
            }
        }
    },
    "ko": {
        "passwords": {
            "password": "비밀번호는 최소한 6자 이상이어야 하며 확인 항목과 일치해야 합니다.",
            "reset": "비밀번호가 변경되었습니다!",
            "sent": "비밀번호 재설정 링크를 이메일로 전송했습니다!",
            "token": "해당 비밀번호 재설정 토큰이 유효하지 않습니다.",
            "user": "해당 이메일을 사용하는 사용자를 찾을 수 없습니다."
        },
        "auth": {
            "failed": "제출된 인증 정보가 레코드와 일치하지 않습니다.",
            "throttle": "너무 많은 로그인을 시도하였습니다. {seconds} 초 후에 다시 시도하십시요.",
            "not_exists": "해당 계정이 존재하지 않습니다."
        },
        "paragraphs": {
            "has_not_service_account": "로그인 어카운트에 할당된 서비스 어카운트가 없습니다.",
            "has_not_service_account_detail": "Kollus Live 사용을 위해선 Kollus 영업팀에 문의해주세요.",
            "list_empty": "가져올 정보가 없습니다.",
            "list_loading": "로딩 중입니다.",
            "recording_list_empty": "가져올 녹화 파일 정보가 없습니다.",
            "placeholder_search": "검색어를 입력하세요.",
            "copied_clipboard": "클립보드에 복사되었습니다.",
            "please_select_file": "업로드할 파일을 선택하세요",
            "are_you_sure": "확실합니까?",
            "are_you_sure_that_update_this": "이것을 수정하시겠습니까?",
            "placeholder_select_division": "구분을 선택하세요.",
            "placeholder_select_channel": "채널 선택하세요.",
            "placeholder_select_broadcast": "라이브 방송 선택하세요.",
            "page_navigation": "%{total} 건 중 %{from} - %{to}",
            "last_updated_date": "최종 업데이트 날짜: %{date}",
            "not_use_policy": "정책을 사용하지 않습니다",
            "use_capture_block_policy": "정책을 사용합니다.",
            "please_select_item": "아이템을 선택하신 후 다시 시도해 주세요.",
            "channel": {
                "it_is_not_on_air": "현재 방송 중이 아닙니다.",
                "latest_broadcast_list_empty": "최신 라이브 내역이 없습니다.",
                "hidden_list_desc": "채널 숨김 시, 채널의 라이브가 중지되며 숨김 해제 전까지 라이브가 불가합니다.",
                "hidden_list_empty": "숨긴 내역이 없습니다.",
                "customer_code_tip": "고객 코드는 영문 소문자, 숫자, '_', '-' 만 가능합니다.",
                "concurrently_view_limit_tip": "제한 수를 상회하는 시청자가 동시 접속 시, 선 접속 허용 후, 시청자의 VG 요청 시간에 따라 후 제한합니다.",
                "use_duplicate_block_if_no_open_channel_tip": "비공개 채널의 경우에만 중복재생 차단이 가능합니다",
                "meta_title_pattern": {
                    "sample_desc": "다음과 같은 치환자로 방송이 생성됩니다.",
                    "sample1": "[CHANNEL_TITLE] : 채널 타이틀",
                    "sample2": "[CHANNEL_CUSTOMER_CODE] : 채널 고객 코드",
                    "sample3": "[BROADCAST_COUNTING] : 방송 회차",
                    "sample4": "[BROADCAST_CREATING_DATE] : 방송 생성 날짜",
                    "sample5": "[PROGRAM_TITLE] : 프로그램 제목"
                },
                "recording_file_policy": {
                    "save_separate_file": "라이브 스트리밍이 끊어질 때마다, 각각의 파일로 저장",
                    "append_one_file": "라이브 스트리밍의 단절 시간이 3분 이내일 경우, 한 파일로 이어 저장"
                },
                "recording_file_pattern": {
                    "tip": "라이브 종료 후 녹화 파일 다운로드 시, 입력한 규칙대로 파일명 지정되어 저장됩니다.",
                    "sample_desc": "다음과 같은 치환자로 방송이 생성됩니다.",
                    "sample1": "[CHANNEL_KEY] : 채널 키",
                    "sample2": "[CHANNEL_CUSTOMER_CODE] : 채널 고객코드",
                    "sample3": "[BROADCAST_KEY] : 방송 키",
                    "sample4": "[BROADCAST_COUNTING] : 방송 회차",
                    "sample5": "[BROADCAST_CREATING_DATE] : 방송 생성 날짜",
                    "sample6": "[RECORDING_START_DATETIME] : 녹화 시작 날짜 시간",
                    "sample7": "[RECORDING_TYPE] : 녹화 종류"
                },
                "creator_tip": "채널 등록 시, 기본 Creator 1명의 코드 및 암호가 자동 생성됩니다. 최대 3명의 Creator까지 생성이 가능합니다. Creator 코드 및 암호는 채널 등록/추가 시 생성되며, Creator 닉네임 및 암호는 관리자에 의하여 변경 가능합니다.",
                "logo_tip_1": "로고 이미지는 플레이어 좌측 상단에 노출 예정입니다.",
                "logo_tip_2": "로고 이미지로는 가로 %{maxWidth}px, 세로 %{maxHeight}px 이하의 gif나 png 파일만 사용할 수 있습니다.",
                "idle_screen_kind_tip_1": "라이브 목록 및 라이브 시작 전 혹은 종료 후, 플레이어 접근 시 대기화면을 설정합니다.",
                "idle_screen_kind_tip_2": "라이브 내역이 없어 스냅샷이 없거나 포스터를 등록하지 않았을 경우, 기본 플레이어 화면이 노출됩니다.",
                "idle_screen_kind": {
                    "use_poster": "이미 등록한 포스터 사용",
                    "use_snapshot": "해당 채널의 최신 라이브 스냅샷 노출"
                },
                "poster_tip_1": "포스터 이미지는 라이브 시작 전 혹은 종료 후, 플레이어 대기화면으로 노출 예정입니다.",
                "poster_tip_2": "포스터 이미지는 gif나 png 파일만 사용할 수 있고 가로 %{maxWidth}px, 세로 %{maxHeight}px 이하의 사이즈로 업로드됩니다.",
                "snapshot_tip_1": "스냅샷 이미지는 라이브 중 5초마다 촬영되어 저장되며 최신 이미지로 갱신 저장됩니다.",
                "snapshot_tip_2": "스냅샷 요청량은 트래픽에 포함되어 과금 됩니다.",
                "placeholder_title": "채널명을 입력해 주세요",
                "placeholder_customer_code": "채널 코드를 입력해 주세요",
                "download_in_7days": "최근 7일 동안의 녹화 파일만 바로보기 가능합니다.",
                "select_start_date_bigger": "시작 날짜는 {date}보다 큰 날짜만 선택 가능합니다.",
                "select_end_date_smaller": "종료 날짜는 {date}보다 작은 날짜만 선택 가능합니다.",
                "mornitorring_message": {
                    "broadcast_start": "크리에이터가 방송을 시작 중입니다.",
                    "broadcast_stop": "크리에이터가 방송을 종료 중입니다."
                },
                "country_restriction_tip_1": "국가별 접근 제거 채널별로 특정 국가로부터의 라이브 동영상 콘텐츠 접근을 허용하거나 제한할 수 있습니다.",
                "country_restriction_tip_2": "국가를 선택하여 추가하시기 바랍니다.",
                "cmaf_desc": "보다 빠른 실시간 라이브 서비스를 위한 CMAF 기반의 Low-Latency HLS 스트리밍입니다.",
                "low_latency_hls_desc": "iOS17.1 미만, Android7.0 미만<br>디바이스가 해당됩니다.",
                "not_available_desc": "이용 불가 채널입니다.<br>이용을 원하시면 영업 담당자(AM, biz@catenoid.net)에게 문의해주세요.",
                "aes128_disabled_desc": "채널 타입이 저지연 방송일 경우, AES-128 사용이 불가합니다.",
                "profile_changed": "'저지연 라이브' 채널 타입을 선택하여 인코딩 프로파일이 변경되었습니다.",
                "multi_drm_changed": "‘AES-128’ 사용함을 선택하여 ‘Multi-DRM’ 사용을 할 수 없습니다."
            },
            "recording_file": {
                "preview_tip1": "녹화 파일의 크기가 클수록 영상 로딩 시간이 걸릴 수 있습니다."
            },
            "profile": {
                "list_empty": "가져올 수 있는 정보가 없습니다.",
                "screen_type": {
                    "portrait": "세로",
                    "landscape": "가로"
                },
                "group_tip1": "인코딩 프로파일을 추가 혹은 수정하기 위해서는 담당 관리자에게 별도 요청이 필요합니다.",
                "group_tip2": "라이브 중인 채널이 존재할 경우 프로파일 변경이 불가능합니다.",
                "use_max_count_tip": "프로파일은 최대 {count} 개 이하로 사용할 수 있습니다.",
                "use_least_count_tip": "프로파일은 최소 {count} 개 이상 사용해야 합니다."
            },
            "statistics": {
                "channel_download_tip": "채널 통계는 라이브 종료 30분 후, 확인 가능합니다.",
                "view_environment_download_tip": "시청자 환경 통계는 라이브 종료 30분 후, 확인 가능합니다.",
                "storage_usage_download_tip": "녹화 파일 이용 통계는 라이브 종료 30분 후, 확인 가능합니다.",
                "service_usage_download_tip": "서비스 이용 통계는 라이브 종료 30분 후, 확인 가능합니다.",
                "service_usage_file_download_tip": "하단의 리스트에서 설정한 정렬 상태대로 파일이 생성됩니다."
            },
            "message": {
                "success": {
                    "remove": "성공적으로 삭제되었습니다.",
                    "change": "성공적으로 변경되었습니다.",
                    "store": "성공적으로 저장되었습니다.",
                    "create": "성공적으로 생성되었습니다.",
                    "update": "성공적으로 수정되었습니다.",
                    "destory": "성공적으로 삭제되었습니다.",
                    "copy": "성공적으로 복사되었습니다.",
                    "remove_broadcast": "성공적으로 방송이 삭제되었습니다.",
                    "remove_recording_file": "성공적으로 녹화 파일이 삭제되었습니다.",
                    "upload": "성공적으로 파일이 업로드되었습니다.",
                    "duplicate_block_player_unregister": "성공적으로 재생기기가 등록 해제되었습니다.",
                    "duplicate_block_player_reset": "성공적으로 모든 재생기기가 등록 해제되었습니다.",
                    "block_user_limit_register": "성공적으로 선택한 사용자를 제한하였습니다.",
                    "block_user_no_limit_register": "성공적으로 선택한 사용자의 제한을 해제하였습니다.",
                    "remove_program_file": "성공적으로 파일이 삭제되었습니다.",
                    "remove_program": "성공적으로 프로그램이 삭제되었습니다.",
                    "clone_channel": "채널이 복사되었습니다."
                },
                "confirm": {
                    "create_item": "선택한 아이템을 생성하시겠습니까?",
                    "update_item": "선택한 아이템을 수정하시겠습니까?",
                    "remove_item": "선택한 아이템을 삭제하시겠습니까?",
                    "hide_channels": "선택한 채널을 숨기시겠습니까? 라이브 방송은 즉시 중단될 것입니다.",
                    "restore_channels": "선택한 채널을 복구하시겠습니까?",
                    "destroy_channels": "선택한 채널을 영원히 삭제하시겠습니까?",
                    "remove_broadcast": "선택한 방송을 삭제하시겠습니까?",
                    "remove_recording_file": "선택한 녹화 파일을 삭제하시겠습니까?",
                    "update_stream_key": "Creator 스트림 키를 변경하시겠습니까?",
                    "start_duplicate_recording_file": "수동 녹화를 시작하시겠습니까?",
                    "stop_duplicate_recording_file": "수동 녹화를 종료하시겠습니까?",
                    "duplicate_block_player_unregister": "재생기기를 등록 해제하시겠습니까?",
                    "duplicate_block_player_register": "재생기기를 등록하시겠습니까?",
                    "duplicate_block_player_reset": "모든 재생기기를 등록 해제하시겠습니까?",
                    "block_user_limit_register": "사용자를 제한하시겠습니까?",
                    "block_user_no_limit_register": "제한한 사용자를 해제하시겠습니까?",
                    "remove_program_file": "선택한 '{title}' {contents_type}을/를 삭제하시겠습니까?",
                    "cancel_upload_file": "업로드를 취소하시겠습니까?",
                    "remove_program": " '{title}' 을 삭제하시겠습니까?",
                    "disable_channel_status": "선택한 채널을 비활성화하시겠습니까? 사용자가 라이브를 볼 수 없게 됩니다.",
                    "enable_channel_status": "선택한 채널을 활성화하시겠습니까? 사용자가 라이브를 볼 수 있습니다."
                },
                "error": {
                    "create": "생성 실패했습니다.",
                    "update": "수정 실패했습니다.",
                    "change": "변경 실패했습니다.",
                    "remove": "삭제할 수 없습니다.",
                    "hide_channels": "채널 숨김에 실패하였습니다.",
                    "restore_channels": "채널 복구에 실패하였습니다.",
                    "destroy_channels": "채널 삭제에 실패하였습니다.",
                    "channel_info": "채널 정보를 가져오는 데 실패하였습니다.",
                    "channel_encoding_info": "인코딩 정보를 가져오는 데 실패하였습니다.",
                    "exceed_maximum_creator_count": "최대 3명의 Creator 생성이 가능합니다.",
                    "update_creator_info": "크리에이터 정보를 수정하는 데 실패하였습니다.",
                    "reload_creator_stream_key": "크리에이터 스크림 키를 새로 고치는 데 실패하였습니다.",
                    "remove_file": "파일을 삭제하는 데 실패하였습니다.",
                    "update_statistics": "통계 정보를 가져오는 데 실패하였습니다.",
                    "remove_broadcast": "방송을 삭제하는 데 실패하였습니다.",
                    "remove_recording_file": "녹화 파일을 삭제하는 데 실패하였습니다.",
                    "upload": "파일 업로드에 실패하였습니다.",
                    "create_creator": "Creator를 생성할 수 없습니다",
                    "remove_creator": "크리에이터를 삭제하는 데 실패하였습니다.",
                    "remove_creator_onair": "방송 중인 크리에이터는 삭제할 수 없습니다.",
                    "exist_in_blocks": "이미 제한 국가에 추가되어 있습니다.",
                    "exist_in_allows": "이미 허용 국가에 추가되어 있습니다.",
                    "remove_country": "국가 삭제에 실패하였습니다.",
                    "empty_country": "추가할 국가를 선택하여 주세요.",
                    "google_auth": "구글 계정 인증에 실패하였습니다.",
                    "logout_google_auth": "구글 계정 삭제에 실패하였습니다.",
                    "check_login_right": "권한을 확인하세요.",
                    "duplicate_recording_not_on_air": "방송 중일 때만 사용이 가능합니다.",
                    "duplicate_recording_cannot_stop": "녹화 중이 아니므로 녹화 종료를 할 수 없습니다.",
                    "duplicate_block_player_unregister": "재생기기를 등록 해제하는데 실패하였습니다.",
                    "duplicate_block_player_reset": "모든 재생기기를 등록 해제하는데 실패하였습니다.",
                    "remove_program_file_ready_schedule": "예정된 편성이 있어서 삭제할 수 없습니다.",
                    "remove_program_file": "파일을 삭제할 수 없습니다.",
                    "remove_program_done_schedule": "진행된 편성이 있어서 프로그램을 삭제할 수 없습니다.",
                    "remove_program": "프로그램을 삭제할 수 없습니다.",
                    "disable_channel_status": "채널 비활성화에 실패하였습니다.",
                    "enable_channel_status": "채널 활성화에 실패하였습니다.",
                    "clone_channel": "채널 복사에 실패하였습니다.",
                    "exist_in_referer_domains": "이미 도메인 목록에 포함되어 있습니다.",
                    "empty_domain": "추가할 도메인을 입력해 주세요.",
                    "empty_check_domains": "허용할 도메인 목록이 존재하지 않습니다.",
                    "empty_reject_domains": "차단할 도메인 목록이 존재하지 않습니다."
                }
            },
            "live_action_logs": {
                "user_login": "유저 로그인했음",
                "creator_login": "크리에이터 로그인했음",
                "channel_created": "채널을 등록함",
                "channel_updated": "채널을 업데이트함",
                "channel_restored": "채널을 복귀함",
                "channel_trashed": "채널을 숨김",
                "channel_deleted": "채널을 삭제함",
                "broadcast_started": "라이브를 시작함",
                "broadcast_paused": "라이브를 잠시 멈춤",
                "broadcast_resumed": "라이브를 재시작함",
                "broadcast_stopped": "라이브를 중지함",
                "country_restriction_created": "국가별 접근 제한을 추가함",
                "country_restriction_deleted": "국가별 접근 제한을 삭제함",
                "file_transfer_created": "녹화 파일 전송을 추가함",
                "file_transfer_updated": "녹화 파일 전송을 수정함",
                "file_transfer_deleted": "녹화 파일 전송을 삭제함",
                "file_transfer_enabled": "녹화 파일 전송을 활성화함",
                "file_transfer_disabled": "녹화 파일 전송을 비활성화함",
                "syndication_created": "신디케이션을 추가함",
                "syndication_updated": "신디케이션을 수정함",
                "syndication_deleted": "신디케이션을 삭제함",
                "syndication_enabled": "신디케이션을 활성화함",
                "syndication_disabled": "신디케이션을 비활성화함",
                "content_provider_updated": "서비스 계정을 업데이트함",
                "recording_file_download": "녹화 파일을 다운로드함",
                "statistics_channel_download": "채널 통계를 다운로드함",
                "statistics_viewer_environment_download": "시청자 환경 통계를 다운로드함",
                "statistics_storage_usage_download": "녹화 파일 이용 통계를 다운로드함",
                "statistics_service_usage_download": "녹화 파일 이용 통계를 다운로드함 ",
                "statistics_service_log_download": "서비스 로그를 다운로드함",
                "creator_updated": "Creator를 수정함",
                "creator_created": "Creator를 생성함",
                "creator_deleted": "Creator를 삭제함",
                "duplicate_recording_file_save_started": "녹화 파일 수동 저장 시작함",
                "duplicate_recording_file_save_stopped": "녹화 파일 수동 저장 종료함",
                "media_content_deleted": "프로그램 파일을 삭제함",
                "media_content_upload_prepared": "프로그램 파일을 업로드 준비함",
                "program_created": "프로그램을 등록함",
                "program_updated": "프로그램을 수정함",
                "program_deleted": "프로그램을 삭제함",
                "statistics_service_usage_new_download": "서비스 이용 통계를 다운로드함",
                "chatting_file_download": "채팅 파일을 다운로드함",
                "channel_enabled": "채널을 활성화함",
                "channel_disabled": "채널을 비활성화함",
                "chatting_statistics_usage_download": "채팅 이용 통계를 다운로드함",
                "chatting_statistics_users_download": "채팅 접속자 통계를 다운로드함",
                "chatting_statistics_messages_download": "채팅 메시지 통계를 다운로드함"
            },
            "please_select": "선택해 주세요",
            "remote_path_desc": "Remote_path",
            "file_transfer_tip1": "녹화 파일을 자동 전송할 파일 전송처를 등록합니다.",
            "file_transfer_tip2": "등록한 전송처로 라이브 녹화 파일을 전송합니다. 최대 {count} 개까지 동시 사용 가능합니다.",
            "file_transfer_max_count_tip": "녹화 파일 전송처는 최대 {count} 개까지 사용할 수 있습니다.",
            "youtube_category_tip1": "유튜브의 경우 구글의 정책에 따라 유튜브 카테고리 가운데 하나를 반드시 선택해야 동영상을 업로드할 수 있습니다.",
            "youtube_category_tip2": "이 설정은 이 채널로부터 유튜브로 업로드되는 모든 동영상 콘텐츠에 적용됩니다.",
            "kollus_category_tip1": "사용 중인 Kollus 카테고리 가운데 하나를 반드시 선택해야 동영상을 업로드할 수 있습니다.",
            "kollus_category_tip2": "이 설정은 이 채널로부터 Kollus로 업로드되는 모든 동영상 콘텐츠에 적용됩니다.",
            "file_transfer_count_tip": "녹화 파일 전송처는 최대 {count} 개까지 등록할 수 있습니다.",
            "please_google_auth": "구글 계정을 인증해 주세요.",
            "loaded_youtube_category": "파일을 업로드할 카테고리가 로딩되었습니다. 카테고리를 선택해 주세요.",
            "syndication_max_count_tip": "신디케이션은 최대 {count} 개까지 사용할 수 있습니다.",
            "syndication_count_tip": "신디케이션은 최대 {count} 개까지 등록할 수 있습니다.",
            "syndication_tip1": "연동할 외부 플랫폼의 신디케이션 정보를 입력합니다. 연동 시, 진행되는 라이브 방송이 추가한 외부 플랫폼을 통해서도 라이브됩니다.",
            "syndication_tip2": "최대 {count}까지 동시 사용 가능합니다.",
            "idle_screen_kind_poster": "이 채널의 대기화면은 등록한 포스터 이미지입니다.",
            "idle_screen_kind_snapshot": "이 채널의 대기화면은 라이브 스냅샷입니다.",
            "license_key_empty": "생성된 License Key가 없습니다. 담당 관리자에게 문의하세요.",
            "downloadable_within_7_days": "다운로드 가능 일수는 기본 7일 입니다.",
            "contract_tip1": "표시된 항목의 경우 추가 과금입니다.",
            "contract_tip2": "그 외 요소에 대한 설정 변경의 경우, 직접 해당 채널의 설정을 수정합니다.",
            "placeholder_service_account_name": "서비스 계정명을 입력하세요.",
            "members_empty": "사용자 정보가 없습니다. 담당 관리자에게 문의하세요.",
            "creators_per_channels_manage_tip1": "채널별 Creator는 실제 라이브를 진행하는 Creator를 의미합니다.",
            "creators_per_channels_manage_tip2": "채널에 맞는 코드와 스트림 키를 입력해야만 라이브 방송이 가능합니다.",
            "has_no_contract": "서비스 어카운트에 연결된 계약이 없습니다.",
            "has_no_contract_detail": "Kollus Live 사용을 위해선 Kollus 영업팀에 문의해주세요.",
            "broadcast_update_callback_tip": "콜백 URL로 라이브 방송 시작, 중지, 종료 시 해당 라이브 정보를 보냅니다",
            "recording_file_transfer_callback_tip": "콜백 URL로 녹화 파일 전송 시 결과 정보를 보냅니다.",
            "lms_callback_tip": "설정한 URL로 콘텐츠 이용 정보를 보냅니다.  https만 사용 가능합니다.",
            "placeholder_callback_url": "콜백 URL을 입력해 주세요.",
            "recording_size_tip": "라이브 중 녹화 파일 용량이 4G를 초과할 때, 녹화 파일 자동 저장",
            "recording_duration_tip1": "라이브 시간이",
            "recording_duration_tip2": "경과할 때마다, 녹화 파일 자동 저장",
            "division_delayed_tip1": "라이브 스트리밍 단절 시간이",
            "division_delayed_tip2": "이내일 경우, 한 방송으로 인식함",
            "oauth_name_tip": "Something your users will recognize and trust.",
            "oauth_redirect_url_tip": "Your application's authorization callback URL.",
            "oauth_personal_access_token_desc": "Here is your new personal access token. This is the only time it will be shown so don't lose it! You may now use this token to make API requests.",
            "oauth_no_clients": "You have not created any OAuth clients.",
            "something_wrong": "문제가 발생하였습니다. 다시 시도해 주세요.",
            "oauth_no_tokens": "You have not created any personal access tokens.",
            "oauth_no_authorized_applications": "You have not created any authorized application.",
            "duplicate_recording_tip1": "수동으로 녹화 파일을 저장합니다.",
            "duplicate_recording_tip2": "라이브 On-Air 시, 녹화 시작/종료 버튼이 활성화되며 버튼 클릭 시, 실제 작동까지 최대 5초의 지연이 발생할 수 있습니다.",
            "duplicate_recording_tip3": "채널 등록 시, 설정한 녹화 자동 저장 기능과 동시에 적용됩니다.",
            "duplicate_recording_in_use": "수동 녹화를 사용자({username})가 진행 중입니다. 잠시 기다려 주세요.",
            "duplicate_recording_ing_tip": "2Mbps(비트레이트)로 라이브 시, 최대 4시간의 녹화 파일을 저장할 수 있습니다.",
            "broadcast_update_callback_desc": "방송 콜백에서 사용되는 파라미터에 대한 설명입니다.",
            "recording_file_transfer_callback_desc": "녹화 파일 전송 파라미터 리스트입니다.",
            "chatting_exclusive_player_disable_desc1": "전용 플레이어 사용 시, 채팅 사용이 불가합니다.",
            "chatting_exclusive_player_disable_desc2": "채팅을 사용하려면 전용 플레이어를 사용 안 함으로 지정해야 합니다.",
            "chatting_use_yes_no_tip": "해당 채널에서 채팅 기능의 사용 여부를 설정합니다.",
            "chatting_type_tip": "임베디드형의 경우, 별도의 개발 없이 바로 적용이 가능하며 개발형의 경우, 사용을 위한 별도의 계약이 필요합니다.",
            "chatting_type_embed_tip": "Chatroll을 연동하여 사용합니다.",
            "chatting_service_not_available": "서비스 계정 계약에서 Chatroll 설정 정보를 추가하신 후 이용하실 수 있습니다.",
            "placeholder_chatting_embed_code": "사용 시, [HTML embed code]를 입력합니다.",
            "chatting_concurrent_user_tip1": "채팅 동시 접속자 수에 관리자/Creator 계정도 포함됩니다.",
            "chatting_concurrent_user_tip2": "일반 사용자보다 먼저 채팅에 참여해 주세요.",
            "chatting_not_available_desc1": "채팅 사용을 위하여 별도 계약이 필요합니다.",
            "chatting_not_available_desc2": "계약 후에도 채팅 입력이 불가할 경우",
            "chatting_not_available_desc3": "채널 수정 페이지에서 채팅 사용 여부를 사용함으로 체크해 주세요.",
            "exceed_max_channel_count": "사용할 수 있는 채널 갯수를 초과하였습니다. 관리자에게 문의해 주세요.",
            "duplicate_block_policy_unavailable": "사용 중인 중복 재생 차단 정책 설정에 의해 이용할 수 없습니다.",
            "placeholder_search_client_user_id": "사용자 아이디를 입력하세요",
            "catting_available_at_html5": "채팅은 HTML5 플레이어에서만 연동됩니다",
            "program_placeholder_title": "프로그램 제목을 입력해 주세요.",
            "recently_ordered_files": "최근 추가된 파일",
            "program_file_search": "파일 검색",
            "broadcast_duration_desc": "파일 추가할 때마다 자동 계산해서 늘어남",
            "program_already_reserved_schedule": "이미 예약된 다른 라이브 방송과 시간이 겹칩니다.",
            "program_cannot_destroy_ongoing_or_finished": "라이브가 종료되거나 진행 중인 프로그램은 삭제할 수 없습니다.",
            "program_file_uploaded": "{file_name}의 업로드가 완료되었습니다. 등록이 완료되면 파일 리스트에 추가됩니다.",
            "program_file_upload_only_mp4": "mp4 파일만 업로드 가능합니다.",
            "program_select_channel": "채널을 선택하신 후 프로그램을 등록하실 수 있습니다.",
            "program_select_start_date": "시작 날짜를 선택해 주세요",
            "chatting_profile_photo_tip_1": "프로파일 사진이 없는 사용자를 위해 사용할 기본 프로파일 사진을 변경합니다.",
            "chatting_profile_photo_tip_2": "이미지는 가로 %{maxWidth}px, 세로 %{maxHeight}px 이하의 이미지 파일을 등록해 주세요.",
            "play_callback_tip": "설정한 URL로 전용 플레이어 재생 정보를 보냅니다.",
            "program_file_upload_desc1": "트랜스코딩을 활성화하면, 파일 변환에 시간이 소요됩니다만, 안정적인 서비스를 위해서 트랜스코딩을 활성화하는 것을 권장합니다.",
            "program_file_upload_desc2": "트랜스코딩을 끄시는 경우,",
            "program_file_upload_desc3": "오디오 샘플 레이트는 48khz를 사용하세요.",
            "program_file_upload_desc4": "오디오/비디오의 포맷을 통일해 주세요.",
            "program_wait_file_search": "대기 화면 검색",
            "program_wait_file_upload_only": "jpg 또는 png 파일만 업로드 가능합니다. 가로 %{maxWidth}px, 세로 %{maxHeight}px 이하의 이미지 파일을 등록해 주세요.",
            "program_wait_file_duration_min": "대기 화면 지속 시간을 입력해 주세요. 지속 시간은 360분 이내로 설정 가능합니다.",
            "program_check_audio_format_error": "오디오 포맷이 다릅니다. 이 경우 파일이 바뀔 때 오디오 싱크가 맞지 않습니다. 트랜스코딩하여 사용하시기 바랍니다.",
            "program_check_video_format_warning": "비디오 포맷이 다릅니다. 이 경우 파일이 바뀔 때 신디케이션을 포함한 기능에 오동작을 일으킬 수 있습니다. 이대로 등록하시겠습니까?",
            "program_can_register_after_5min": "편성은 현재 시각에서 5분 지난 시점부터 등록이 가능합니다.",
            "program_file_please_register": "프로그램에서 사용할 파일을 등록해 주세요.",
            "channel_cannot_change_kind_program_to_general": "예약된 프로그램이 있어서 채널 타입을 변경할 수 없습니다.",
            "file_not_exist_for_download": "다운로드받을 수 있는 파일이 존재하지 않습니다.",
            "chatting_admin_id_tooltip": "채팅 관리자는 jwt의 client_user_id(cuuid)에 입력한 값을 기준으로 하며, 공백을 구분자로 하여 입력하여 주세요.",
            "chatting_disabled_when_use_anonymous": "익명 채팅을 사용 중일 경우 프로파일 사진 설정을 사용할 수 없습니다.",
            "chatting_profile_photo_cannot_disable_when_not_display_profile_photo": "프로파일 사진을 노출하지 않을 경우 기본 프로파일 이미지를 변경할 수 없습니다.",
            "chatting_profile_photo_cannot_upload_when_not_disable_profile_photo": "기본 프로파일 이미지를 사용하는 경우 프로파일 이미지를 변경할 수 없습니다.",
            "chatting_scalable_tip": "예상되는 채팅 사용자 수가 3,000명 이상일 경우 대규모 채팅을 활성화하시기 바랍니다.",
            "chatting_send_status_tip": "채팅 SDK를 사용하시는 경우에만 활성화하시기 바랍니다.",
            "chatting_restart_broadcast_to_apply": "채팅 관리자 아이디 이외의 항목은 방송을 다시 시작해야 적용됩니다.",
            "referer_check_tip_1": "특정한 도메인에서 라이브 스트림이 재생 또는 차단되도록 설정하고자 할 경우, 원하는 도메인을 입력해 주세요. 한 번에 여러 개의 도메인을 등록하고자 할 경우에는 \",\"로 구분하시면 됩니다.",
            "referer_check_tip_2": "Wildcard처럼 특정 문자열 앞부분의 문자열을 허용하려면 \"#\"을 이용해 주세요.",
            "referer_check_tip_3": "(예시 : 'abcd.com,go.abcd.com,aa.abcd.com' 등록이 필요할 경우,#abcd.com 이용)",
            "referer_check_domain_rule": "{domain}을 확인해 주세요.",
            "chatting_statistics_tip": "채팅 이용 통계는 라이브 종료 30분 후, 확인 가능합니다.",
            "statistics_timezone_tip": "통계 자료의 기준 시간대는 UTC(GMT +00{00}) 입니다.",
            "latency_config_check_integer_gte_0": "{attribute}은(는)  0 이상 정수를 입력해야 합니다.",
            "latency_config_check_integer_gte_1": "{attribute}은(는)  1 이상 정수를 입력해야 합니다.",
            "profile_type_match_tip": "인코딩 프로파일 그룹의 타입과 인코딩 프로파일의 타입이 일치해야 합니다.",
            "program_wait_file_upload_only_desc": "대기화면 파일은 jpg 또는 png 파일만 업로드 가능합니다. <br>가로 %{maxWidth}px, 세로 %{maxHeight}px 이하의 이미지 파일을 등록해 주세요.",
            "not_use_filelive": "녹화 방송 정책을 사용하지 않습니다.",
            "not_use_webrtc": "WebRTC 정책을 사용하지 않습니다.",
            "not_use_contract": "해당 정책을 사용하지 않습니다.",
            "profile_group_type_match_tip": "인코딩 프로파일 그룹의 타입과 채널의 타입이 일치해야 합니다.",
            "program_same_audio_codec_and_sample_rate": "동일한 오디오코덱, 샘플레이트 파일로만 프로그램을 편성할 수 있습니다.",
            "program_conflicting_schedule": "이미 편성된 프로그램과 시간이 겹칩니다.",
            "program_wait_file_duration_min_max": "최대 360분까지 설정할 수 있습니다.",
            "program_register_modal_title_placeholder": "프로그램 제목을 입력하세요.",
            "program_register_modal_contents_info": "동일한 오디오 코덱, 샘플레이트 콘텐츠로만 프로그램을 편성할 수 있습니다.",
            "program_title_required": "프로그램 제목 입력은 필수입니다.",
            "program_channel_required": "채널 선택 필드는 필수입니다.",
            "program_wait_content_duration_over_zero": "최대 360분까지 설정할 수 있습니다.<br>대기화면 지속 시간은 1 이상 정수를 입력해야 합니다.",
            "program_content_file_required": "콘텐츠 선택 필드는 필수입니다.<br>동일한 오디오 코덱, 샘플레이트 콘텐츠로만 프로그램을 편성할 수 있습니다.",
            "program_check_video_format_error": "비디오 포맷이 다릅니다. 이 경우 파일이 바뀔 때 신디케이션을 포함한 기능에 오동작을 일으킬 수 있습니다.",
            "program_hide_channel_notification": "숨긴 채널의 프로그램으로 라이브되지 않습니다.",
            "schedule_live_on_modify_error": "라이브 중인 프로그램은 수정할 수 없습니다.",
            "schedule_live_end_modify_error": "라이브 종료된 프로그램은 수정할 수 없습니다.",
            "schedule_live_modify_success": "라이브 스케쥴을 변경하였습니다.",
            "schedule_live_modify_fail": "라이브 스케쥴 변경에 실패했습니다.",
            "schedule_copy_warning": "수정된 정보를 저장하고 복제하시겠습니까? 취소 시 변경 내용이 사라집니다.",
            "schedule_modal_close_warning": "입력한 정보들은 저장되지 않습니다. 그래도 닫으시겠습니까?",
            "schedule_modal_close_modified_save": "수정한 정보를 저장하시겠습니까?",
            "program_check_video_format_each_contents": "콘텐츠간 {fail_format}이/가 서로 다릅니다.",
            "program_check_audio_format_each_contents": "콘텐츠간 {fail_format}이/가 서로 다릅니다.",
            "program_check_video_format_between_contents_and_wait": "콘텐츠와 대기화면간 {fail_format}이/가 서로 다릅니다.",
            "program_check_audio_format_between_contents_and_wait": "콘텐츠와 대기화면간 {fail_format}이/가 서로 다릅니다.",
            "program_check_video_format_confirm": "선택된 파일들의 {fail_format}가 다릅니다. 이 경우 파일이 바뀔 때 신디케이션을 포함한 기능에 오동작을 일으킬 수 있습니다. 이대로 등록하시겠습니까?",
            "no_contents_list": "검색 결과가 없습니다.",
            "program_select_channel_placeholder": "채널을 선택해주세요.",
            "program_contents_search": "콘텐츠 검색",
            "program_have_none_transcoding_done_files": "트랜스코딩이 완료된 콘텐츠만 편성이 가능합니다.",
            "program_wait_file_upload_wrong_format": "파일 이름으로 ~&()\\|/?<>'\";:`%는 사용할 수 없습니다.",
            "program_upload_fail_error": "네트워크 연결이 원활하지 않아 확인 후 재업로드 해주세요.",
            "not_use_cmaf": "CMAF 정책을 사용하지 않습니다.",
            "not_use_aes128": "사용을 원하시면 기술 담당자(PE, tech_support@catenoid.net)에게 문의해 주세요.",
            "block_external_output_display_desc": "모바일 기기의 TV-OUT 출력 또는 PC(Windows)에서의 빔프로젝터 출력을 차단합니다.",
            "block_angle_brackets": "꺾쇠 기호(<, >)는 입력할 수 없습니다.",
            "invalid_service_account_input": "서비스 계정명에는 이모지(Emoji) 및 꺾쇠 기호(<, >) 입력이 제한됩니다."
        },
        "pagination": {
            "previous": "&laquo; 이전",
            "next": "다음 &raquo;"
        },
        "words": {
            "login": "로그인",
            "logout": "로그아웃",
            "login_account": "로그인 계정",
            "has_not_service_account": "서비스 계정 없음",
            "role": "역할",
            "timezone": "타임존",
            "language": "언어",
            "broadcast": "방송",
            "broadcasts": "방송들",
            "live": "라이브 방송",
            "filesize": "파일 크기",
            "list": "목록",
            "channel": "채널",
            "channels": "채널들",
            "all_broadcasts": "전체 방송",
            "all_channels": "전체 채널",
            "live_onair": "방송중",
            "email": "이메일",
            "email_address": "이메일",
            "password": "패스워드",
            "remember_me": "계정 기억하기",
            "select_all": "전체 선택",
            "key": "키",
            "preview": "미리보기",
            "visitor_counts": "조회수",
            "name": "이름",
            "count": "횟수",
            "title": "제목",
            "customer_code": "고객 코드",
            "all": "전체",
            "open": "공개",
            "restore": "복구",
            "not_open": "비공개",
            "live_status": "방송 상태",
            "live_status_on": "방송중",
            "live_status_off": "방송 종료",
            "shared_status": "공개 여부",
            "shared_status_on": "공개",
            "shared_status_off": "비공개",
            "channel_manage": "채널 관리",
            "channel_list": "채널 리스트",
            "hidden_channel_list": "숨김 목록",
            "recording_files": "녹화 파일 리스트",
            "creator": "Creator",
            "decoration": "로고/포스터/스냅샷",
            "statistics_manage": "통계 관리",
            "statistics": "통계",
            "statistics_channel": "채널 통계",
            "statistics_viewer_env": "시청자 환경 통계",
            "storage_usage": "녹화 파일 이용 통계",
            "service_logs": "서비스 로그",
            "preference": "설정",
            "general": "일반",
            "basic_info": "기본 정보",
            "profile": "프로파일",
            "members": "Members",
            "close": "닫기",
            "go_detail": "자세히 보기",
            "datetime": "날짜",
            "save": "저장",
            "cancel": "취소",
            "add": "추가",
            "upload": "업로드",
            "copy": "복사",
            "search": "검색",
            "use_yes": "사용함",
            "use_no": "사용 안함",
            "remove": "삭제",
            "logo": "로고",
            "idle_screen_kind": "대기화면 설정",
            "poster": "포스터",
            "snapshot": "스냅샷",
            "started_at": "시작 시각",
            "ended_at": "종료 시각",
            "broadcast_interval": "방송 시간",
            "live_counts": "라이브 횟수",
            "concurrently_viewer_limit": "동시 시청자 수 제한",
            "latest_live_broadcast": "최근 라이브 방송",
            "title_and_creator": "제목/Creator",
            "started_and_ended": "시작 시간/종료 시간",
            "accumulate_viewers": "누적 시청자 수",
            "hidden_date": "숨겨진 일시",
            "profile_group_name": "프로파일 그룹명",
            "profile_selected_name": "종류",
            "profile_group_screen_type": "형태",
            "media_profile_groups": "인코딩 프로파일",
            "is_shared": "공개 여부",
            "use_duplicate_block": "중복 재생 차단",
            "meta_title_pattern": "메타 정보 제목",
            "meta_description": "메타 정보 내용",
            "recording_file_pattern": "녹화 파일 저장 규칙",
            "recording_file_policy": "녹화 파일 저장 방식",
            "use_capture_block": "플레이어 녹화/캡처 방지",
            "use_exclusive_player": "전용 플레이어",
            "use_timeshift": "Timeshift",
            "creator_nickname": "Creator 닉네임",
            "creator_code": "Creator 코드",
            "creator_stream_key": "Creator 스트림 키",
            "create_channel": "채널 등록",
            "edit_channel": "채널 수정",
            "hide_channels": "채널 숨김",
            "remove_channels": "채널 삭제",
            "restore_channels": "채널 복구",
            "remove_recording_files": "녹화 파일 삭제",
            "remove_broadcasts": "방송 삭제",
            "broadcast_list": "방송 리스트",
            "today": "오늘",
            "store": "저장",
            "edit": "수정",
            "description": "내용",
            "video_gateway_link": "비디오 게이트웨이 링크",
            "channel_key": "채널 키",
            "link": "링크",
            "application": "애플리케이션",
            "stream_key": "스트림 키",
            "show": "보기",
            "delete": "삭제",
            "detail_information": "상세정보",
            "creator_information": "Creator 상세정보",
            "all_creators": "전체 Creator 들",
            "onair_creator": "방송 중인 크리에이터",
            "broardcast_ip_address": "송출 IP",
            "broadcast_started_at": "송출 시간",
            "broadcast_location": "송출 지역",
            "recording_file_created_volume": "녹화 파일 생성 용량",
            "live_count": "라이브 횟수",
            "statistics_download": "통계 다운로드",
            "statistics_storage_usage": "녹화 파일 이용 통계",
            "statistics_service_logs": "서비스 로그",
            "action_datetime": "작업 일시",
            "division": "구분",
            "action_user": "작업자",
            "subject_name": "대상",
            "action_message": "작업 내용",
            "user_login": "유저 로그인",
            "creator_login": "Creator 로그인",
            "channel_created": "채널 생성",
            "channel_updated": "채널 수정",
            "channel_restored": "채널 복귀",
            "channel_trashed": "채널 숨김",
            "channel_deleted": "채널 삭제",
            "broadcast_started": "라이브 시작",
            "broadcast_paused": "라이브 멈춤",
            "broadcast_resumed": "라이브 재시작",
            "broadcast_stopped": "라이브 중지",
            "no_limit": "무제한",
            "period_today": "TODAY",
            "period_3d": "3D",
            "period_7d": "7D",
            "period_30d": "30D",
            "previous": "Previous",
            "next": "Next",
            "watch_time": "시청 시간",
            "max_acc_user": "누적 시청자 수",
            "total_acc_user": "순 시청자 수",
            "max_cur_user": "최대 동시 시청자 수",
            "total_visit_count": "조회수",
            "total_broadcast_interval": "총 방송 시간",
            "average_broadcast_interval": "평균 방송 시간",
            "total_watch_time": "총 시청 시간",
            "average_watch_time": "평균 시청 시간",
            "watch_user": "시청자 수",
            "visit_count": "조회수",
            "traffic": "트래픽",
            "transfer": "전송량",
            "response_code": "Response code",
            "country": "국가",
            "domainOrUrl": "도메인/URL별",
            "device": "디바이스별",
            "os": "운영체제별",
            "browser": "브라우저별",
            "channel_name": "채널명",
            "live_name": "라이브명",
            "acc_user_count": "누적 순 시청자 수",
            "cur_user_count": "실시간 동시 시청자 수",
            "request_count": "조회수",
            "response_code_1xx_desc": "1xx(조건부 응답)",
            "response_code_2xx_desc": "2xx(성공)",
            "response_code_3xx_desc": "3xx(리다이렉트 완료)",
            "response_code_4xx_desc": "4xx(요청 오류)",
            "response_code_5xx_desc": "5xx(서버 오류)",
            "unit_user_count": "명",
            "unit_request_count": "건",
            "live_info": "라이브 정보",
            "channel_info": "채널 정보",
            "live_title": "라이브 제목",
            "remove_recording_file": "녹화 파일 삭제",
            "kollus_live_cms": "Kollus LIVE",
            "quality": "품질",
            "video": "비디오",
            "audio": "오디오",
            "use_yes_no": "사용 여부",
            "codec": "코덱",
            "resolution": "해상도",
            "bitrate": "비트레이트",
            "media_player_policy_none": "없음",
            "media_player_policy_only": "전용 플레이어",
            "media_player_policy_only_at_mobile": "모바일 전용 플레이어",
            "country_restriction": "국가별 접근 제어",
            "allowed_country": "허용 국가",
            "blocked_country": "제한 국가",
            "allowed_country_select": "허용 국가 선택",
            "blocked_country_select": "제한 국가 선택",
            "recording_file_transfer": "녹화 파일 전송",
            "register": "등록",
            "file_transfer_kind": "파일 전송처",
            "category": "카테고리",
            "youtube_upload_open": "유튜브 업로드 공개",
            "authentication": "인증",
            "aws_bucket_name_desc": "S3 버킷 명",
            "aws_access_key_id_desc": "AWS S3 access key 정보",
            "aws_secret_access_key_desc": "AWS S3 secret access key 정보",
            "use_encryption": "encryption 사용 여부",
            "google_auth_go": "구글 계정 인증하기",
            "platform_name": "플랫폼명",
            "syndication": "신디케이션",
            "category_key": "카테고리 키",
            "contract_info": "계약 정보",
            "service_account": "서비스 계정",
            "service_account_name": "서비스 계정명",
            "service_account_key": "서비스 계정 키",
            "member_manage": "사용자 관리",
            "service_duration": "서비스 시작일 ~ 종료일",
            "service_type": "서비스 타입",
            "contract_channel_count": "계약 채널 수",
            "max_birate": "최대 비트레이트",
            "player": "플레이어",
            "forwarding_target_limit_count": "전송처 제한 수",
            "license_key": "License Key",
            "platform": "플랫폼",
            "event": "이벤트",
            "mobile_encoder_sdk": "Mobile Encoder SDK",
            "create_date": "생성일",
            "expire_date": "만료일",
            "package_name/bundle_id": "패키지명/번들 ID",
            "authentication_key": "인증키",
            "ios": "iOS",
            "android": "Android",
            "content_provider_updated": "서비스 계정 수정",
            "login_info": "로그인 정보",
            "user_info": "사용자 정보",
            "manage": "관리",
            "role_owner": "최고 관리자",
            "role_manager": "관리자",
            "role_viewer": "운영자",
            "role_creator": "Creator",
            "menu": "메뉴",
            "detail_function": "세부 기능",
            "view": "보기",
            "modify": "수정",
            "channel_edit": "채널 수정",
            "channel_hide/restore": "채널 숨김/해제(방송 중지)",
            "channel_detail": "채널 상세",
            "mnu_live": "라이브",
            "recording_file_download": "녹화 파일 다운로드",
            "recording_file_remove": "녹화 삭제",
            "live_info_desc": "라이브 정보 (제목, 설명, 포스터, 신디케이션)",
            "kollus_live_role_guide": "Kollus live 권한 가이드",
            "creators_per_channels_manage": "채널별 Creator 관리",
            "download": "다운로드",
            "security_key": "보안 키",
            "custom_key": "사용자 키",
            "callback": "콜백",
            "broadcast_update_callback": "라이브 콜백",
            "broadcast_update_callback_url": "라이브 콜백 URL",
            "recording_file_transfer_callback": "녹화 파일 전송 콜백",
            "recording_file_transfer_callback_url": "녹화 파일 전송 콜백 URL",
            "lms_callback": "LMS 콜백",
            "lms_callback_url": "LMS 콜백 URL",
            "live_broadcast_policy": "라이브 방송 정책",
            "save_maximum_volume": "맥시멈 용량 저장",
            "save_interval_time": "인터벌 타임 저장",
            "unit_minute": "분",
            "recording_file_policy_save_no_file": "파일 저장 안함",
            "recording_file_policy_save_auto_file": "자동 파일 저장",
            "recording_file_policy_save_manual_file": "수동 파일 저장",
            "recording_file_policy_save_all_file": "자동 & 수동 파일 저장",
            "save_auto": "자동 저장",
            "save_manual": "수동 저장",
            "oauth_clients": "OAuth Clients",
            "personal_access_tokens": "Personal Access Tokens",
            "client_id": "Client ID",
            "secret": "Secret",
            "create_new_client": "Create New Client",
            "create_new_token": "Create New Token",
            "redirect_url": "Redirect URL",
            "scopes": "Scopes",
            "create_client": "Create Client",
            "edit_client": "Edit Client",
            "go_kollus_live_api": "Kollus Live API",
            "create_token": "Create Token",
            "personal_access_token": "Personal Access Token",
            "authorized_applications": "Authorized Applications",
            "statistics_channel_download": "채널 통계 다운로드",
            "statistics_viewer_env_download": "시청자 통계 다운로드",
            "statistics_storage_usage_download": "녹화 파일 이용 통계 다운로드",
            "statistics_service_usage_download": "녹화 파일 이용 통계 다운로드",
            "statistics_service_log_download": "서비스 로그 다운로드",
            "recording_started_at": "녹화 시작 시각",
            "recording_ended_at": "녹화 종료 시각",
            "recording_type": "녹화 종류",
            "play_now": "바로보기",
            "recording_download": "녹화 다운",
            "auto": "자동",
            "manual": "수동",
            "recording_start": "녹화 시작",
            "recording_stop": "녹화 종료",
            "duplicate_recording_start": "수동 녹화 시작",
            "duplicate_recording_stop": "수동 녹화 종료",
            "duplicate_recording_ing": "수동 녹화중",
            "broadcast_key": "라이브 키",
            "stream_start": "스트림 시작",
            "stream_stop": "스트림 종료",
            "stream_pause": "라이브 방송 정책에 따른 기간 안의 스트림 정지",
            "stream_resume": "라이브 방송 정책에 따른 기간 안의 스트림 재시작",
            "recording_file_name": "녹화 파일 이름",
            "recording_file_kind": "녹화 파일 종류. segment: 자동 녹화, duplicate: 수동 녹화",
            "recording_file_transfer_result": "전송 결과. 0: 실패, 1: 성공",
            "chatting": "채팅",
            "chatting_use_yes_no": "채팅 사용 여부",
            "chatting_type": "채팅 종류",
            "chatting_type_embed": "임베디드형",
            "catting_go_chatroll_config": "Chatroll 설정 바로가기",
            "chatting_position": "채팅 위치",
            "top": "위",
            "bottom": "아래",
            "right": "오른쪽",
            "left": "왼쪽",
            "type": "종류",
            "auto_recording_files_viewer": "자동 녹화 파일 바로보기",
            "manual_recording_files_viewer": "수동 녹화 파일 바로보기",
            "auto_recording_file": "자동 녹화 파일",
            "manual_recording_file": "수동 녹화 파일",
            "auto_recording": "자동 녹화",
            "manual_recording": "수동 녹화",
            "help_center": "고객지원",
            "aws_region_key_desc": "AWS S3 region key 정보",
            "password_change": "비밀번호 변경",
            "old_password": "기존 비밀번호",
            "new_password": "변경할 비밀번호",
            "password_confirm": "변경할 비밀번호 확인",
            "video_gateway": "비디오 게이트웨이",
            "show_channel_title_at_vg": "채널 제목 표시",
            "show_broadcast_title_at_vg": "라이브 제목 표시",
            "show_meta_description_at_vg": "메타 정보 내용 표시",
            "duplicate_block": "중복 재생 차단",
            "duplicate_block_manage": "중복 재생 차단 관리",
            "duplicate_block_sessions": "재생 중인 세션",
            "duplicate_block_logs": "중복 재생 차단 로그",
            "player_id": "플레이어 아이디",
            "client_user_id": "사용자 아이디",
            "session_unregister": "세션 종료",
            "duplicate_block_policy": "중복 재생 차단 정책",
            "duplicate_block_policy_allow_one_device_at_same_time": "동시에 하나의 재생기기로부터의 접근만 허용",
            "duplicate_block_policy_allow_registered_device": "등록된 재생기기로부터의 접근만 허용 (개수 지정)",
            "duplicate_block_policy_allow_registered_one_device_at_same_time": "등록된 재생기기 가운데 동시에 하나의 접근만 허용 (개수 지정)",
            "duplicate_block_reset_all_player_id": "모든 재생기기 등록 해제",
            "duplicate_block_delete_player_id": "재생기기 등록 해제",
            "duplicate_block_delete_client_user_id": "사용자 아이디 등록 해제",
            "reset": "초기화",
            "player_id_register": "플레이어 아이디 등록",
            "created_at": "등록 날짜",
            "capture_block_policy": "캡처 차단 정책",
            "capture_block_policy_stop_playback_and_alert_warning": "재생 중단 및 경고 처리",
            "capture_block_policy_stop_playback_alert_warning_and_restrict_user_content_access": "재생 중단 및 경고 처리 & 사용자 콘텐츠 접근 제한",
            "capture_block_policy_use_teruten": "Teruten",
            "capture_block_policy_use_teruten_stop_playback_and_alert_warning": "재생 중단 및 경고 처리 + Teruten",
            "capture_block_policy_use_teruten_block_process": "Teruten + 프로세스 차단",
            "capture_block_policy_block_process": "프로세스 차단",
            "capture_block": "캡처 차단",
            "capture_block_logs": "캡처 차단 로그",
            "used_capture_tool": "사용된 캡쳐 툴",
            "player_kmpi": "모바일 플레이어(iOS)",
            "player_kmpa": "모바일 플레이어(Android)",
            "player_mac": "맥 전용플레이어",
            "player_knp": "전용 플레이어(NP Player) - 윈도우(Safari)",
            "player_kap": "전용 플레이어(ActiveX) - IE",
            "player_kag": "V3/V4 Player(HTML5, Application)",
            "player_type": "플레이어 타입",
            "player_block": "제한",
            "player_unblock": "제한 해제",
            "block_user_list": "제한한 사용자 목록",
            "hardware_id": "하드웨어 ID",
            "general_channel": "일반 채널",
            "program_channel": "편성 채널",
            "file_list": "파일 리스트",
            "program_schedule": "프로그램 편성",
            "file_name": "파일 이름",
            "file_size": "파일 크기",
            "play_time": "재생 시간",
            "upload_time": "업로드 시간",
            "program_count_finished": "편성 횟수 (완료)",
            "program_count_ready": "편성 횟수 (예정)",
            "program_manage": "편성 관리",
            "file_register": "파일 등록",
            "program_register": "새 프로그램 편성",
            "program_modify": "프로그램 수정",
            "no_title": "제목 없음",
            "file": "파일",
            "total_broadcast_time": "총 방송 시간",
            "broadcast_start_date": "방송 시작 날짜",
            "channel_kind": "채널 타입",
            "program_created": "프로그램 등록",
            "program_updated": "프로그램 수정",
            "program_deleted": "프로그램 삭제",
            "media_content_deleted": "프로그램 파일 삭제",
            "media_content_upload_prepared": "프로그램 파일 업로드 준비",
            "transcoding_on": "트랜스코딩 중",
            "transcoding_error": "트랜스코딩 에러",
            "include_removed_channels": "삭제된 채널 포함",
            "chatting_limit_count": "1분간 전송 가능한 메시지 수",
            "chatting_join_message": "사용자 환영 메시지",
            "chatting_profile_photo": "프로파일 사진",
            "chatting_profile_photo_display": "프로파일 사진 노출",
            "chatting_profile_default_photo_change": "기본 프로파일 이미지 변경",
            "play_callback": "재생 콜백",
            "play_callback_url": "재생 콜백 URL",
            "transcoding": "트랜스코딩",
            "status": "상태",
            "use_possible": "사용 가능",
            "register_wait": "등록 대기",
            "register_fail": "등록 실패",
            "wait_media_content": "대기 화면",
            "wait_media_content_duration_m": "대기 화면 지속 시간",
            "program": "편성",
            "hide_channel": "숨김 채널",
            "statistics_service_usage": "서비스 이용 통계",
            "syndication_time": "신디케이션 시간",
            "start_time": "시작 시간",
            "end_time": "종료 시간",
            "statistics_service_usage_new_download": "서비스 이용 통계 다운로드",
            "chatting_anonymous_chat": "익명 채팅",
            "chatting_enable_block": "사용자 차단 기능 활성화",
            "chatting_download": "채팅 다운로드",
            "chatting_file_download": "채팅 파일 다운로드",
            "chatting_unique_user_count": "채팅 참여자 수",
            "chatting_sum_message_count": "채팅 메세지 수",
            "chatting_admin_id": "채팅 관리자 아이디",
            "vod_storage_statistics": "VOD 스토리지 통계",
            "enable": "활성화",
            "disable": "비활성화",
            "channel_enabled": "채널 활성화",
            "channel_disabled": "채널 비활성화",
            "multi_drm": "Multi DRM",
            "widevine_revoked_device": "Widevine 인증 철회 기기",
            "allow_play": "재생 허용",
            "block_play": "재생 차단",
            "chatting_download_fields": "다운로드할 필드 선택",
            "concurrently_chatting_limit": "채팅 참여자 수 제한",
            "chatting_download_file_type": "다운로드할 파일 타입",
            "file_live": "File Live",
            "scalable_chatting": "대규모 채팅",
            "webrtc_channel": "WebRTC 채널",
            "chatting_send_status": "좋아요",
            "chatting_usage_statistics": "채팅 이용 통계",
            "chatting_statistics_usage_download": "채팅 이용 통계 다운로드",
            "chatting_unique_count": "채팅 참여자 수",
            "chatting_message_count": "채팅 메시지 수",
            "average_chatting_unique_count": "평균 채팅 접속자 수",
            "average_chatting_message_count": "평균 채팅 메시지 수",
            "referer_config": "레퍼러 설정",
            "referer_check_domains": "허용할 도메인 목록",
            "referer_reject_domains": "차단할 도메인 목록",
            "referer_check_option_disable": "비활성화",
            "referer_check_option_check": "특정 도메인에서만 재생 허용",
            "referer_check_option_reject": "특정 도메인에서의 재생 차단",
            "domain": "도메인",
            "channel_clone": "채널 복사",
            "profile_group_key": "프로파일 그룹 키",
            "webrtc": "WebRTC",
            "realtime_live": "실시간 방송",
            "recording_live": "녹화 방송",
            "realtime": "실시간",
            "recording": "녹화",
            "latency_time_config": "지연 시간 설정",
            "unit_second": "초",
            "unit_quantity": "개",
            "size": "크기",
            "program_ready_time": "편성 예정 시간",
            "audio_codec": "오디오 코덱",
            "sample_rate": "샘플레이트",
            "frame_rate": "프레임 레이트",
            "original": "원본",
            "tr": "TR",
            "dont_delete_message": "예정된 편성이 있어서 삭제할 수 없습니다.",
            "transcoding_fail": "트랜스코딩 실패",
            "contents_list": "콘텐츠 리스트",
            "wait_media_content_list": "대기화면 리스트",
            "contents_register": "콘텐츠 업로드",
            "wait_media_content_register": "대기화면 업로드",
            "upload_file_desc": "파일을 끌어놓거나, 브라우저에서 선택해 주세요.",
            "upload_progress": "전체 {progress}% 업로드 진행",
            "upload_status_wait": "업로드 대기",
            "upload_status_done": "업로드 성공",
            "upload_status_cancel": "업로드 취소",
            "upload_status_fail": "업로드 실패",
            "success_upload_clear": "성공한 항목 정리",
            "max_uploading_count_message": "동시에 최대 20개까지만 업로드가 가능합니다.",
            "file_max_size_message": "파일 크기가 2GB 넘는 파일은 업로드 대상에서 제외 됩니다.",
            "contents": "콘텐츠",
            "recoding_channel": "녹화 채널",
            "all_recoding_channel": "전체 녹화 채널",
            "program_live_status_live": "라이브 중",
            "program_live_status_end": "라이브 종료",
            "contents_name_search": "콘텐츠 이름 검색",
            "only_upload_success_contents_comments": "업로드 성공 콘텐츠만 보기",
            "admin_login": "Administrator 로그인",
            "upload_transcoding_desc_1_1": "트랜스코딩 진행률은 콘텐츠 리스트 메뉴에서 확인 가능합니다.",
            "upload_transcoding_desc_1_2": "트랜스코딩이 완료되면 콘텐츠 리스트에서 파일 크기(GiB), 재생 시간이 확정됩니다.",
            "upload_transcoding_desc_2_1": "트랜스코딩 진행률은 대기화면 리스트 메뉴에서 확인 가능합니다.",
            "upload_transcoding_desc_2_2": "트랜스코딩이 완료되면 대기화면 리스트에서 파일 크기(GiB), 재생 시간이 확정됩니다.",
            "upload_transcoding_desc_2_3": "대기화면은 체크여부에 상관없이 자동 트랜스코딩됩니다.",
            "program_title": "프로그램 제목",
            "contents_select": "콘텐츠 선택",
            "program_hide_channel_info": "숨김 채널의 라이브 방송은 즉시 중단됩니다.",
            "max_age": "Max age",
            "chunk_duration": "Chunk duration",
            "chunk_count": "Chunk count",
            "complete_upload_clear": "완료된 항목 정리",
            "transcoding_wait": "대기중",
            "max_fps": "최대 FPS",
            "chatting_block_dup_nickname": "중복 닉네임 차단",
            "cmaf": "저지연 라이브",
            "programming_live": "편성 라이브",
            "unit_millisecond": "밀리초",
            "chunk_part_duration_cmaf": "Chunk part duration",
            "channel_low_latency_hls": "저사양 디바이스 HLS",
            "use_aes128": "AES-128",
            "channel_not_available": "이용 불가",
            "block_external_output_display": "외부 디스플레이 출력 차단"
        },
        "validation": {
            "accepted": "{attribute}을(를) 동의해야 합니다.",
            "active_url": "{attribute}은(는) 유효한 URL이 아닙니다.",
            "after": "{attribute}은(는) {date} 이후 날짜여야 합니다.",
            "after_or_equal": "{attribute}은(는) {date} 이후 날짜이거나 같은 날짜여야 합니다.",
            "alpha": "{attribute}은(는) 문자만 포함할 수 있습니다.",
            "alpha_dash": "{attribute}은(는) 문자, 숫자, 대쉬(-)만 포함할 수 있습니다.",
            "alpha_num": "{attribute}은(는) 문자와 숫자만 포함할 수 있습니다.",
            "array": "{attribute}은(는) 배열이어야 합니다.",
            "before": "{attribute}은(는) {date} 이전 날짜여야 합니다.",
            "before_or_equal": "{attribute}은(는) {date} 이전 날짜이거나 같은 날짜여야 합니다.",
            "between": {
                "numeric": "{attribute}은(는) {min}에서 {max} 사이여야 합니다.",
                "file": "{attribute}은(는) {min}에서 {max} 킬로바이트 사이여야 합니다.",
                "string": "{attribute}은(는) {min}에서 {max} 문자 사이여야 합니다.",
                "array": "{attribute}은(는) {min}에서 {max} 개의 항목이 있어야 합니다."
            },
            "boolean": "{attribute}은(는) true 또는 false 이어야 합니다.",
            "confirmed": "{attribute} 확인 항목이 일치하지 않습니다.",
            "date": "{attribute}은(는) 유효한 날짜가 아닙니다.",
            "date_format": "{attribute}이(가) {format} 형식과 일치하지 않습니다.",
            "different": "{attribute}와(과) {other}은(는) 서로 달라야 합니다.",
            "digits": "{attribute}은(는) {digits} 자리 숫자여야 합니다.",
            "digits_between": "{attribute})은(는) {min}에서 {max} 자리 사이여야 합니다.",
            "dimensions": "{attribute}은(는) 유효하지 않는 이미지 크기입니다.",
            "distinct": "{attribute} 필드에 중복된 값이 있습니다.",
            "email": "{attribute}은(는) 유효한 이메일 주소여야 합니다.",
            "exists": "선택된 {attribute}은(는) 유효하지 않습니다.",
            "file": "{attribute}은(는) 파일이어야 합니다.",
            "filled": "{attribute} 필드는 값이 있어야 합니다.",
            "gt": {
                "numeric": "{attribute}의 값은 {value}보다 커야 합니다.",
                "file": "{attribute}의 용량은 {value}킬로바이트보다 커야 합니다.",
                "string": "{attribute}의 길이는 {value}보다 길어야 합니다.",
                "array": "{attribute}의 항목수는 {value}개 보다 많아야 합니다."
            },
            "gte": {
                "numeric": "{attribute}의 값은 {value}보다 같거나 커야 합니다.",
                "file": "{attribute}의 용량은 {value}킬로바이트보다 같거나 커야 합니다.",
                "string": "{attribute}의 길이는 {value}보다 같거나 길어야 합니다.",
                "array": "{attribute}의 항목수는 {value}개 보다 같거나 많아야 합니다."
            },
            "image": "{attribute}은(는) 이미지여야 합니다.",
            "in": "선택된 {attribute}은(는) 유효하지 않습니다.",
            "in_array": "{attribute} 필드는 {other}에 존재하지 않습니다.",
            "integer": "{attribute}은(는) 정수여야 합니다.",
            "ip": "{attribute}은(는) 유효한 IP 주소여야 합니다.",
            "ipv4": "{attribute}은(는) 유효한 IPv4 주소여야 합니다.",
            "ipv6": "{attribute}은(는) 유효한 IPv6 주소여야 합니다.",
            "json": "{attribute}은(는) JSON 문자열이어야 합니다.",
            "lt": {
                "numeric": "{attribute}의 값은 {value}보다 작아야 합니다.",
                "file": "{attribute}의 용량은 {value}킬로바이트보다 작아야 합니다.",
                "string": "{attribute}의 길이는 {value}보다 짧아야 합니다.",
                "array": "{attribute}의 항목수는 {value}개 보다 작아야 합니다."
            },
            "lte": {
                "numeric": "{attribute}의 값은 {value}보다 같거나 작아야 합니다.",
                "file": "{attribute}의 용량은 {value}킬로바이트보다 같거나 작아야 합니다.",
                "string": "{attribute}의 길이는 {value}보다 같거나 짧아야 합니다.",
                "array": "{attribute}의 항목수는 {value}개 보다 같거나 작아야 합니다."
            },
            "max": {
                "numeric": "{attribute}은(는) {max}보다 클 수 없습니다.",
                "file": "{attribute}은(는) {max}킬로바이트보다 클 수 없습니다.",
                "string": "{attribute}은(는) {max}자보다 클 수 없습니다.",
                "array": "{attribute}은(는) {max}개보다 많을 수 없습니다."
            },
            "mimes": "{attribute}은(는) 다음의 파일 형식이어야 합니다: {values}.",
            "mimetypes": "{attribute}은(는) 다음의 파일 형식이어야 합니다: {values}.",
            "min": {
                "numeric": "{attribute}은(는) 최소한 {min}이어야 합니다.",
                "file": "{attribute}은(는) 최소한 {min}킬로바이트이어야 합니다.",
                "string": "{attribute}은(는) 최소한 {min}자이어야 합니다.",
                "array": "{attribute}은(는) 최소한 {min}개의 항목이 있어야 합니다."
            },
            "not_in": "선택된 {attribute}이(가) 유효하지 않습니다.",
            "not_regex": "{attribute}의 형식이 올바르지 않습니다.",
            "numeric": "{attribute}은(는) 숫자여야 합니다.",
            "present": "{attribute} 필드가 있어야 합니다.",
            "regex": "{attribute} 형식이 유효하지 않습니다.",
            "required": "{attribute} 필드는 필수입니다.",
            "required_if": "{other}이(가) {value} 일 때 {attribute} 필드는 필수입니다.",
            "required_unless": "{other}이(가) {value}에 없다면 {attribute} 필드는 필수입니다.",
            "required_with": "{values}이(가) 있는 경우 {attribute} 필드는 필수입니다.",
            "required_with_all": "{values}이(가) 모두 있는 경우 {attribute} 필드는 필수입니다.",
            "required_without": "{values}이(가) 없는 경우 {attribute} 필드는 필수입니다.",
            "required_without_all": "{values}이(가) 모두 없는 경우 {attribute} 필드는 필수입니다.",
            "same": "{attribute}와(과) {other}은(는) 일치해야 합니다.",
            "size": {
                "numeric": "{attribute}은(는) {size} (이)여야 합니다.",
                "file": "{attribute}은(는) {size}킬로바이트여야 합니다.",
                "string": "{attribute}은(는) {size}자여야 합니다.",
                "array": "{attribute}은(는) {size}개의 항목을 포함해야 합니다."
            },
            "string": "{attribute}은(는) 문자열이어야 합니다.",
            "timezone": "{attribute}은(는) 올바른 시간대 이어야 합니다.",
            "unique": "{attribute}은(는) 이미 사용 중입니다.",
            "uploaded": "{attribute}을(를) 업로드하지 못했습니다.",
            "url": "{attribute} 형식은 유효하지 않습니다.",
            "uuid": "{attribute}은(는) 유효한 UUID가 아닙니다.",
            "lower_enum_key": "선택된 {attribute}은(는) 유효하지 않습니다.",
            "optimus_exists": "선택된 {attribute}은(는) 유효하지 않습니다.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                },
                "https_url": "{attribute}은(는) https URL 이어야 합니다.",
                "ip_port": "{attribute}은(는) ip{port} 이어야 합니다."
            },
            "no_emoji": "이모지(Emoji)는 입력할 수 없습니다.",
            "no_angle_brackets": "꺾쇠 기호(<, >)는 입력할 수 없습니다.",
            "attributes": {
                "meta_title_pattern": "메타 정보 제목",
                "meta_description": "메타 정보 내용",
                "title": "제목",
                "upload_file": "업로드 파일",
                "customer_code": "고객 코드",
                "editor_title": "제목",
                "category": "카테고리",
                "link": "링크",
                "stream_name": "스트림키",
                "category_key": "카테고리 키",
                "old_password": "기존 비밀번호",
                "new_password": "변경할 비밀번호",
                "password_confirm": "변경할 비밀번호 확인",
                "chunk_count_cmaf": "chunk count",
                "chunk_duration_cmaf": "chunk duration",
                "chunk_part_duration_cmaf": "chunk part duration"
            }
        }
    }
}
